/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

UI.control_add(new control_create("col_cast", "Cast", CONTROL_SLIDER, 0, 255, 0, col_UI_grad_gray, col_UI_grad_orange, col_UI_gray_arrow));
UI.control_add(new control_create("cast_color", "Cast Color:", CONTROL_COLOR, 0, 0, 0, col_white, col_white, col_black));

UI.control_add(new control_create("col_sat", "Saturation", CONTROL_SLIDER, 0, 256, 128, col_UI_gray, col_UI_blue, col_UI_gray_arrow));
UI.control_add(new control_create("col_brt", "Brightness", CONTROL_SLIDER, 0, 127, 64, col_black, col_white, col_UI_gray_arrow));
UI.control_add(new control_create("col_con", "Contrast", CONTROL_SLIDER, 0, 127, 0, col_white, col_black, col_UI_gray_arrow));

UI.control_add(new control_create("pf_width", "Pixel Width", CONTROL_SLIDER, 0.1, 12, 1.75, col_white, col_white, col_black));
UI.control_flags("pf_width", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("pf_displace", "Stripe Size", CONTROL_SLIDER, 5, 50, 12.5, col_white, col_white, col_black));
UI.control_add(new control_create("pf_shape", "Shape", CONTROL_SLIDER, 2, 1000, 100, col_white, col_white, col_black));
UI.control_add(new control_create("pf_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("pf_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("pf_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("ikat_width", "Stripe Width", CONTROL_SLIDER, 0.02, 0.5, 0.2, col_white, col_white, col_black));
UI.control_flags("ikat_width", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("ikat_shape", "Shape", CONTROL_SLIDER, 100, 1000, 100, col_white, col_white, col_black));
UI.control_add(new control_create("ikat_spacing", "Spacing", CONTROL_SLIDER, 5, 150, 25, col_white, col_white, col_black));
UI.control_add(new control_create("ikat_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("ikat_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("ikat_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("stripe_width", "Stripe Size", CONTROL_SLIDER, 0.02, 12, 0.5, col_white, col_white, col_black));
UI.control_flags("stripe_width", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("stripe_variation", "Stripe Variation", CONTROL_SLIDER, 5, 100, 50, col_white, col_white, col_black));
UI.control_add(new control_create("stripe_rnd1", "Randomize 1", CONTROL_SLIDER, 1, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("stripe_rnd2", "Randomize 2", CONTROL_SLIDER, 1, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("stripe_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("glacier_width", "Scale", CONTROL_SLIDER, 0.25, 12, 2, col_white, col_white, col_black));
UI.control_flags("glacier_width", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("glacier_rnd1", "Randomizer 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("glacier_rnd2", "Randomizer 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("glacier_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("crimp_size", "Size", CONTROL_SLIDER, 0.04, 4, 0.5, col_white, col_white, col_black));
UI.control_flags("crimp_size", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("crimp_wave", "Wavelength", CONTROL_SLIDER, 8, 25, 10, col_white, col_white, col_black));
UI.control_add(new control_create("crimp_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 255, 4, col_white, col_white, col_black));
UI.control_add(new control_create("crimp_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 255, 0, col_white, col_white, col_black));
UI.control_add(new control_create("crimp_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("thatch_width", "Stripe Width", CONTROL_SLIDER, 0.02, 0.4, 0.05, col_white, col_white, col_black));
UI.control_add(new control_create("thatch_shape", "Shape", CONTROL_SLIDER, 100, 500, 100, col_white, col_white, col_black));
UI.control_flags("thatch_width", CON_FLAG_PROPORTIONAL);
UI.control_flags("thatch_shape", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("thatch_spacing", "Spacing", CONTROL_SLIDER, 5, 150, 25, col_white, col_white, col_black));
UI.control_add(new control_create("thatch_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("thatch_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("thatch_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("scatter_scale", "Scale", CONTROL_SLIDER, 0.04, 4, 1, col_white, col_white, col_black));
UI.control_flags("scatter_scale", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("scatter_spacing", "Spacing", CONTROL_SLIDER, 25, 300, 80, col_white, col_white, col_black));
UI.control_add(new control_create("scatter_shape", "Shape", CONTROL_SLIDER, -500, 500, 0, col_white, col_white, col_black));
UI.control_add(new control_create("scatter_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("scatter_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("scatter_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("cairo_size", "Size", CONTROL_SLIDER, 0.5, 6, 3, col_white, col_white, col_black));
UI.control_flags("cairo_size", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("cairo_angle", "Angle", CONTROL_SLIDER, 0, 90, 0, col_white, col_white, col_black));
UI.control_add(new control_create("cairo_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("cairo_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("cairo_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("zag_thickness", "Thickness", CONTROL_SLIDER, 0.04, 12, 1, col_white, col_white, col_black));
UI.control_add(new control_create("zag_width", "Width", CONTROL_SLIDER, 0.15, 12, 1.5, col_white, col_white, col_black));
UI.control_add(new control_create("zag_height", "Height", CONTROL_SLIDER, 0.15, 12, 1.5, col_white, col_white, col_black));
UI.control_flags("zag_thickness", CON_FLAG_PROPORTIONAL);
UI.control_flags("zag_width", CON_FLAG_PROPORTIONAL);
UI.control_flags("zag_height", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("zag_variation", "Variation", CONTROL_SLIDER, 0, 100, 50, col_white, col_white, col_black));
UI.control_add(new control_create("zag_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("zag_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("zag_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("sequence_width", "Width", CONTROL_SLIDER, 0.04, 4, 0.25, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_height", "Height", CONTROL_SLIDER, 0.15, 12, 6.5, col_white, col_white, col_black));
UI.control_flags("sequence_width", CON_FLAG_PROPORTIONAL);
UI.control_flags("sequence_height", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("sequence_variation", "Variation", CONTROL_SLIDER, 5, 100, 50, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_break", "Break", CONTROL_SLIDER, 0, 250, 0, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_shuffle", "Shuffle", CONTROL_SLIDER, 0, 300, 150, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("sequence_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("ice_scale", "Scale", CONTROL_SLIDER, 0.1, 12, 0.15, col_white, col_white, col_black));
UI.control_flags("scatter_scale", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("ice_spacing", "Spacing", CONTROL_SLIDER, 20, 300, 90, col_white, col_white, col_black));
UI.control_add(new control_create("ice_shape", "Shape", CONTROL_SLIDER, 20, 300, 100, col_white, col_white, col_black));
UI.control_add(new control_create("ice_shuffle", "Shuffle", CONTROL_SLIDER, 0, 250, 0, col_white, col_white, col_black));
UI.control_add(new control_create("ice_angle", "Angle", CONTROL_SLIDER, 0, 45, 0, col_white, col_white, col_black));
UI.control_add(new control_create("ice_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("ice_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("ice_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("cape_scale", "Scale", CONTROL_SLIDER, 0.1, 12, 1, col_white, col_white, col_black));
UI.control_flags("cape_scale", CON_FLAG_PROPORTIONAL);
UI.control_add(new control_create("cape_stripe", "Stripe Size", CONTROL_SLIDER, 5, 50, 6, col_white, col_white, col_black));
UI.control_add(new control_create("cape_shape", "Shape", CONTROL_SLIDER, 3, 60, 12, col_white, col_white, col_black));
UI.control_add(new control_create("cape_rnd1", "Randomize 1", CONTROL_SLIDER, 0, 256, 4, col_white, col_white, col_black));
UI.control_add(new control_create("cape_rnd2", "Randomize 2", CONTROL_SLIDER, 0, 256, 0, col_white, col_white, col_black));
UI.control_add(new control_create("cape_rotation", "Rotation", CONTROL_SLIDER, 0, 360, 0, col_white, col_white, col_black));

UI.control_add(new control_create("color", "Fill Color:", CONTROL_COLOR, 0, 0, 0, col_white, col_white, col_black));

UI.control_add(new control_create("undo", "Undo:", CONTROL_CHECKBOX, 0, 1, -1, col_white, col_white, col_black));
UI.control_add(new control_create("reset", "Reset:", CONTROL_CHECKBOX, 0, 1, -1, col_white, col_white, col_black));

// -----------------------------------------

if (typeof pf_nodejs !== "undefined")
{

var BlobBuilder = function() {
  this.parts = "";
}

BlobBuilder.prototype.append = function(part) {
	this.parts += part;
};

BlobBuilder.prototype.getBlob = function() {
	return this.parts;
};

}
else
{

var BlobBuilder = function() {
  this.parts = [];
}

BlobBuilder.prototype.append = function(part) {
  this.parts.push(part);
  this.blob = undefined; // Invalidate the blob
};

BlobBuilder.prototype.getBlob = function() {
  if (!this.blob) {
    this.blob = new Blob(this.parts, { type: "image/svg" });
  }
  return this.blob;
};

}

// ----------------------------------------- %BIN

var bin_data;
var bin_data_size;
var bin_data_2nd_start;
var bin_group_pos;
var bin_group_items;

function bin_head4(dv, string)
{
	for (var a = 0; a < 4; a++)
		dv.setInt8(a, string.charCodeAt(a));
}

function bin_head2(dv, string)
{
	for (var a = 0; a < 2; a++)
		dv.setInt8(a, string.charCodeAt(a));
}


function bin_start(scale, start)
{
	var width, height;

	if (!api_slice)
	{
		width = dim_wid/scale;
		height = dim_hei/scale;
	}
	else
	{
		width = api_detail_data.dim[0];
		height = api_detail_data.dim[1];
	}

	if (start)
	{
		bin_data = new ArrayBuffer(1024*1024*256);
		bin_data_size = 0;
	}
	else
		bin_data_2nd_start = bin_data_size;

	data = new DataView(bin_data, bin_data_size, 16+8);
	bin_head4(data, "VDC ");
	data.setInt32(4, 0x0301, true); // format version
	data.setFloat32(8, width, true);
	data.setFloat32(12, height, true);
	data.setInt32(16, 0x77777777, true);
	data.setInt32(20, 0x77777777, true);
	bin_data_size += 24;
}

function bin_view(size)
{
	var dv = new DataView(bin_data, bin_data_size, size);
	bin_data_size += size;
	return (dv);
}

function bin_group_start(layer, note)
{
	bin_group_pos = bin_data_size;
	bin_group_items = 0;
	var g = bin_view(4+4+32+8);
	bin_head4(g, "GRP ");
	for (var a = 0; a < min(layer.length, 32); a++)
		g.setInt8(8 + a, layer.charCodeAt(a));
	g.setInt8(8 + 32, note);
	g.setInt8(8 + 33, 0x77); // reserve
	g.setInt8(8 + 34, 0x77); // reserve
	g.setInt8(8 + 35, 0x77); // reserve
	g.setInt32(8 + 36, 0x77777777, true); // reserve
}

function bin_group_end()
{
	var g = new DataView(bin_data, bin_group_pos+4,4);
	g.setInt32(0, bin_group_items, true);
}

function bin_shape_id(x, y, id, fill, color, alfa, line_width)
{
	var g = bin_view(2+5*4+1);

	bin_head2(g, "ID");
	g.setInt32(2, id, true);
	g.setFloat32(6, x, true);
	g.setFloat32(10, y, true);
	g.setInt32(14, RGB2INT(color), true);
	g.setFloat32(18, alfa, true);
	g.setInt8(22, fill);
	bin_group_items++;
}

function bin_shape_poly4(x1, y1, x2, y2, x3, y3, x4, y4, fill, color, alfa, line_width)
{
	var g = bin_view(2+10*4+1);

	bin_head2(g, "P4");
	g.setFloat32(2, x1, true);
	g.setFloat32(6, y1, true);
	g.setFloat32(10, x2, true);
	g.setFloat32(14, y2, true);
	g.setFloat32(18, x3, true);
	g.setFloat32(22, y3, true);
	g.setFloat32(26, x4, true);
	g.setFloat32(30, y4, true);
	g.setInt32(34, RGB2INT(color), true);
	g.setFloat32(38, alfa, true);
	g.setInt8(42, fill);
	bin_group_items++;
}
// ----------------------------------------- %SVG

var svgz_data = "";
var svgz_shapes = 0;

function svgz_start_init(width, height)
{
	svgz_data = new BlobBuilder();

	svgz_data.append(
		'<?xml version="1.0" standalone="yes"?>\n'+
		'<svg width="'+width+'in" height="'+height+'in" viewBox="0 0 '+width+' '+height+'" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">>\n');
	//svgz_def = 0;
}

function svgz_start(scale)
{
	if (!api_slice)
		svgz_start_init(""+(dim_wid/scale).toFixed(3)+"", ""+(dim_hei/scale).toFixed(3)+"");
	else
		svgz_start_init(""+(api_detail_data.dim[0]).toFixed(3)+"", ""+(api_detail_data.dim[1]).toFixed(3)+"");
}

function svgz_string(str)
{
	svgz_data.append(str+'\n');
}

function svgz_get_style(fill, color, alfa, line_width, cap)
{
	var col_fill, col_stroke;

	if (fill)
	{
		col_fill = color;
		col_stroke = "transparent";
	}
	else
	{
		col_stroke = color;
		col_fill = "transparent";
	}

	var style = 'style="fill:'+col_fill+';stroke:'+col_stroke+';stroke-width:'+line_width+';opacity:'+alfa.toFixed(3)+'"';
	return style;
}

function svgz_get_style2(color, alfa, line_width, cap)
{
	col_stroke = color;

	var style = 'style="stroke:'+col_stroke+';stroke-width:'+line_width+';stroke-linecap:'+cap+';opacity:'+alfa.toFixed(3)+'"';
	return style;
}

function svgz_shape_id(x, y, id, fill, color, alfa, line_width)
{
	var style = 'style="fill:'+color+';opacity:'+alfa.toFixed(3)+';stroke-opacity:'+alfa.toFixed(3)+';stroke:'+color+';'+'"';

	svgz_data.append(
		'<use xlink:href="#s'+id+'" x="'+x.toFixed(4)+'" y="'+y.toFixed(4)+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_rect(x, y, wid, hei, fill, color, alfa, line_width)
{
	if (wid < 0)
	{
		x += wid;
		wid *= -1;
	}
	if (hei < 0)
	{
		y += hei;
		hei *= -1;
	}
	var style = svgz_get_style(fill, color, alfa, line_width);

	svgz_data.append(
		'<rect x="'+x.toFixed(4)+'" y="'+y.toFixed(4)+'" width="'+wid.toFixed(4)+'" height="'+hei.toFixed(4)+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_circle(x, y, r, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);

	x = x.toFixed(4); y = y.toFixed(4); r = r.toFixed(4);

	svgz_data.append(
		'<circle cx="'+x+'" cy="'+y+'" r="'+r+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_triangle(x, y, xx, yy, xxx, yyy, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);

	x = x.toFixed(4); y = y.toFixed(4); xx = xx.toFixed(4); yy = yy.toFixed(4); xxx = xxx.toFixed(4); yyy = yyy.toFixed(4);

	svgz_data.append(
		'<polygon points="'+x+','+y+' '+xx+','+yy+' '+xxx+','+yyy+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_polygon4_def(x1, y1, x2, y2, x3, y3, x4, y4)
{
	x1 = x1.toFixed(4); y1 = y1.toFixed(4); x2 = x2.toFixed(4); y2 = y2.toFixed(4); x3 = x3.toFixed(4); y3 = y3.toFixed(4); x4 = x4.toFixed(4); y4 = y4.toFixed(6);

	svgz_data.append(
		'<polygon points="'+x1+','+y1+' '+x2+','+y2+' '+x3+','+y3+' '+x4+','+y4+'" style="stroke-width:0.005;stroke-linejoin:miter;stroke-linecap:butt" />\n');
	svgz_shapes++;
}

function svgz_polygon4(x1, y1, x2, y2, x3, y3, x4, y4, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);

	x1 = x1.toFixed(4); y1 = y1.toFixed(4); x2 = x2.toFixed(4); y2 = y2.toFixed(4); x3 = x3.toFixed(4); y3 = y3.toFixed(4); x4 = x4.toFixed(4); y4 = y4.toFixed(4);

	svgz_data.append(
		'<polygon points="'+x1+','+y1+' '+x2+','+y2+' '+x3+','+y3+' '+x4+','+y4+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_polygon6(x1, y1, x2, y2, x3, y3, x4, y4, x5, y5, x6, y6, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);

	x1 = x1.toFixed(4); y1 = y1.toFixed(4); x2 = x2.toFixed(4); y2 = y2.toFixed(4); x3 = x3.toFixed(4); y3 = y3.toFixed(4); x4 = x4.toFixed(4); y4 = y4.toFixed(4);
	x5 = x1.toFixed(4); y5 = y1.toFixed(4); x6 = x2.toFixed(4); y6 = y2.toFixed(4);
	svgz_data.append(
		'<polygon points="'+x1+','+y1+' '+x2+','+y2+' '+x3+','+y3+' '+x4+','+y4+' '+x5+','+y5+' '+x6+','+y6+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_polygonN(pts, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);
	var a, l = pts.length;
	var str = "";

	for (a = 0; a < l; a += 2)
		str += pts[a].toFixed(4)+','+pts[a+1].toFixed(4)+(a+2 != l ? ',' : '');

	svgz_data.append(
		'<polygon points="'+str+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_bezier_id(x, y, id, fill, color, alfa, line_width)
{
	var style = 'style="fill:'+color+';opacity:'+alfa.toFixed(3)+'"';

	svgz_data.append(
		'<use xlink:href="#s'+id+'" x="'+x.toFixed(3)+'" y="'+y.toFixed(3)+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_bezier(pts, fill, color, alfa, line_width, scale, pos_x, pos_y)
{
	var style = svgz_get_style(fill, color, alfa, line_width);
	var a = 0, l = pts.length;
	var str = "";

	str += 'M'+((pts[a]-pos_x)/scale).toFixed(3)+' '+((pts[a+1]-pos_y)/scale).toFixed(3)+' ';
	a += 2;
	for (; a < l; a += 6)
		str += 'C'+((pts[a]-pos_x)/scale).toFixed(3)+' '+((pts[a+1]-pos_y)/scale).toFixed(3)+' '+((pts[a+2]-pos_x)/scale).toFixed(3)+' '+((pts[a+3]-pos_y)/scale).toFixed(3)+' '+((pts[a+4]-pos_x)/scale).toFixed(3)+' '+((pts[a+5]-pos_y)/scale).toFixed(3);
	str +=' Z';

	svgz_data.append(
		'<path d="'+str+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_bezier_def(pts)
{
	var a = 0, l = pts.length;
	var str = "";

	str += 'M'+(pts[a]).toFixed(3)+' '+(pts[a+1]).toFixed(3)+' ';
	a += 2;
	for (; a < l; a += 6)
		str += 'C'+(pts[a]).toFixed(3)+' '+(pts[a+1]).toFixed(3)+' '+(pts[a+2]).toFixed(3)+' '+(pts[a+3]).toFixed(3)+' '+(pts[a+4]).toFixed(3)+' '+(pts[a+5]).toFixed(3);
	str +=' Z';

	svgz_data.append(
		'<path d="'+str+'"  style="stroke:transparent;stroke-width:0;" />\n');
}

function svgz_quadratic_id(x, y, id, fill, color, alfa, line_width)
{
	var style = 'style="fill:'+color+';opacity:'+alfa.toFixed(3)+'"';

	svgz_data.append(
		'<use xlink:href="#s'+id+'" x="'+x.toFixed(3)+'" y="'+y.toFixed(3)+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_quadratic(pts, fill, color, alfa, line_width)
{
	var style = svgz_get_style(fill, color, alfa, line_width);
	var a = 0, l = pts.length;
	var str = "";

	str += 'M'+pts[a].toFixed(3)+' '+pts[a+1].toFixed(3)+' ';
	a += 2;
	for (; a < l; a += 4)
		str += 'Q'+pts[a].toFixed(3)+' '+pts[a+1].toFixed(3)+' '+pts[a+2].toFixed(3)+' '+pts[a+3].toFixed(3);
	str +=' Z';

	svgz_data.append(
		'<path d="'+str+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_quadratic_def(pts)
{
	var a = 0, l = pts.length;
	var str = "";

	str += 'M'+pts[a].toFixed(3)+' '+pts[a+1].toFixed(3)+' ';
	a += 2;
	for (; a < l; a += 4)
		str += 'Q'+pts[a].toFixed(3)+' '+pts[a+1].toFixed(3)+' '+pts[a+2].toFixed(3)+' '+pts[a+3].toFixed(3);
	str +=' Z';

	svgz_data.append(
		'<path d="'+str+'" style="stroke:transparent;stroke-width:0;" />\n');
}

function svgz_line(x1, y1, x2, y2, color, alfa, line_width, cap)
{
	var style = svgz_get_style2(color, alfa, line_width, cap);
	x1 = x1.toFixed(4); y1 = y1.toFixed(4); x2 = x2.toFixed(4); y2 = y2.toFixed(4);

	svgz_data.append(
		'<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" '+style+' />\n');
	svgz_shapes++;
}

function svgz_group_start(name)
{
	svgz_data.append('<g id="'+name+'">\n');
	svgz_shapes = 0;
}

function svgz_group_end()
{
	svgz_data.append('</g>\n');
}

function svgz_end()
{
	svgz_data.append("</svg>\n");
	//return svgz_data.getBlob();
}

// ------------------------------------------------------------------------------ %BIN


	function paint_bin_defs(vectors, scale, layer)
	{
		var c = vectors.length;

		var x, y, x2, y2, x3, y3;
		var pts;
		var cc, b, p;
		var shape;

		for (a = 0; a < c; a++)
		{
			g = vectors[a];

   			if (g.g == 'shl_o')
   			{
   				shape = g.pts;
				pts = new Array();
   				cc = shape.length;

   				for (b = 0; b < cc; b += 2)
   				{
   					x = shape[b];
   					y = shape[b+1];

					pts.push(x/scale, y/scale);
   				}

   				var data = bin_view(2+4+1+cc*4);
   				bin_head2(data, "DQ");
   				data.setInt32(2, ((layer*shape_def_size) + g.id), true);
   				data.setInt8(6, cc>>1);
   				for (b = 0; b < cc; b++)
   					data.setFloat32(7 + b*4, pts[b], true);
   			}
   			else
   			if (g.g == 'bez_o')
   			{
   				shape = g.pts;
				pts = new Array();
   				cc = shape.length;

   				for (b = 0; b < cc; b += 2)
   				{
   					x = shape[b];
   					y = shape[b+1];

					pts.push(x/scale, y/scale);
   				}

   				var data = bin_view(2+4+1+cc*4);
   				bin_head2(data, "DB");
   				data.setInt32(2, layer, true);
   				data.setInt8(6, cc>>1);
   				for (b = 0; b < cc; b++)
   					data.setFloat32(7 + b*4, pts[b], true);
   			}
   			else
   			if (g.g == 'p_o')
   			{
   				shape = g.pts;
				pts = new Array();
   				cc = shape.length;

   				for (b = 0; b < cc; b += 2)
   				{
   					x = shape[b];
   					y = shape[b+1];

					pts.push(x/scale, y/scale);
   				}

   				var data = bin_view(2+4+1+cc*4);
   				bin_head2(data, "DP");
   				data.setInt32(2, ((layer*shape_def_size) + g.id), true);
   				data.setInt8(6, cc >> 3);
   				for (b = 0; b < cc; b++)
   					data.setFloat32(7 + b*4, pts[b], true);
   			}
	   	}
	}

	function paint_bin(vectors, mode, layer, scale, api, alfa)
	{
		var c = vectors.length;

		var x, y, x2, y2, x3, y3;
		var pts;
		var cc, b, p;
		var shape;
		var pos_x = 0, pos_y = 0;

		if (api_slice)
		{
			pos_x = api_detail_data.pos[0];
			pos_y = api_detail_data.pos[1];
		}

		for (a = 0; a < c; a++)
		{
			g = vectors[a];
			if (!api)
				switch (mode)
				{
					case 1: if (g.c == "#ffffff") continue; break;
					case 2: if (g.c != "#ffffff") continue; break;
					case 3: if (g.g != "bg") return;
				}
			if (g.g == 'p')
			{
				var v = new Array();
				for (var key in g)
				{
					if (key[0] == 'x')
					{
						v.push((g[key]-pos_x)/scale);
					}
					else
					if (key[0] == 'y')
					{
						v.push((g[key]-pos_y)/scale);
					}
   				}
   				bin_shape_poly4(v[0], v[1], v[2], v[3], v[4], v[5], v[6], v[7], 1, g.c, 1*alfa, 0);
			}
   			else
   			if (g.g == 'p_p' || g.g == 'p_pp' || g.g == 'shl_p' || g.g == 'bez_p')
   			{
   				bin_shape_id((g.x-pos_x)/scale, (g.y-pos_y)/scale, (layer*shape_def_size) + g.id, 1, g.c, g.a*alfa, 0);
   			}/*
   			else
   			if (g.g == 'bez_p')
   			{
   				svgz_bezier_id(g.x/scale, g.y/scale, layer, 1, g.c, g.a*alfa, 0);
   			}*/
   			else
   			if (g.g == 'bg' && ((glass_type != 1 && mode == 3 && !api) || api))
   			{
   				if (!api_slice)
   				{
   					x = g.x/scale;
   					y = g.y/scale;
   					x2 = g.w/scale
   					y2 = g.h/scale;
   					x2 += x;
   					y2 += y;
   				}
   				else
   				{
   					x = g.x - api_detail_data.bleed;
   					y = g.y - api_detail_data.bleed;
   					x2 = g.x + api_detail_data.dim[0] + api_detail_data.bleed;
   					y2 = g.y + api_detail_data.dim[1] + api_detail_data.bleed;
   				}
   				bin_shape_poly4(x, y, x2, y, x2, y2, x, y2, 1, g.c, ((!glass_type ? 1 : 0.6)*alfa) * api_fill_alpha);
			}


		}
	}

// ------------------------------------------------------------------------------ %SVG

	function paint_svg_defs(vectors, scale, layer)
	{
		var c = vectors.length;

		var x, y, x2, y2, x3, y3;
		var pts;
		var cc, b, p;
		var shape;

		for (a = 0; a < c; a++)
		{
			g = vectors[a];

   			if (g.g == 'shl_o')
   			{
   				svgz_string('<defs><g id="s'+((layer*shape_def_size)+g.id)+'">');

				pts = new Array();
				shape = g.pts;
   				cc = shape.length;
   				b = 0;
   				x = shape[b];
   				y = shape[b+1];
   				pts.push(x/scale, y/scale);
   				b += 2;
   				while (b < cc)
   				{
   					x = shape[b];
   					y = shape[b+1];
   					b += 2;
   					x2 = shape[b];
   					y2 = shape[b+1];
   					b += 2;
   					pts.push(x/scale, y/scale, x2/scale, y2/scale);
   				}
   				svgz_quadratic_def(pts);
   				svgz_string("</g></defs>")
   			}
   			else
   			if (g.g == 'bez_o')
   			{
   				svgz_string('<defs><g id="s'+layer+'">');

   				shape = new Array();

   				cc = g.pts.length;
   				b = 0;
   				x = g.pts[b];
   				y = g.pts[b+1];
 				shape.push(x/scale, y/scale);
   				b += 2;

   				while (b < cc)
   				{
   					x = g.pts[b];
   					y = g.pts[b+1];
   					shape.push(x/scale, y/scale);
   					b += 2;
   					x2 = g.pts[b];
   					y2 = g.pts[b+1];
   					shape.push(x2/scale, y2/scale);
   					b += 2;
   					x3 = g.pts[b];
   					y3 = g.pts[b+1];
   					shape.push(x3/scale, y3/scale);
   					b += 2;
   				}
				svgz_bezier_def(shape);
   				svgz_string("</g></defs>")
   			}
   			else
   			if (g.g == 'p_o')
   			{
   				svgz_string('<defs><g id="s'+((layer*shape_def_size) + g.id)+'">');

   				shape = g.pts;
				pts = new Array();
   				cc = shape.length;

   				for (b = 0; b < cc; b += 2)
   				{
   					x = shape[b];
   					y = shape[b+1];

					pts.push(x/scale, y/scale);
   				}
   				for (b = p = 0; b < cc; b += 8, p += 8)
   					svgz_polygon4_def(pts[p+0], pts[p+1], pts[p+2], pts[p+3], pts[p+4], pts[p+5], pts[p+6], pts[p+7]);

   				svgz_string("</g></defs>")
   			}
	   	}
	}

	function paint_svg_shapes(vectors, layer)
	{
		var c = vectors.length;

		var x, y, x2, y2, x3, y3;
		var pts;
		var cc, b, p;
		var shape;

		for (a = 0; a < c; a++)
		{
			g = vectors[a];

  			if (g.g == 'p_i' || g.g == 'shl_i' || g.g == 'bez_i')
   			{
   				shape_def_size = g.num;
   				//if (api_layers == 1) shape_def_size = 0;
   			}
	   	}
	}

	function paint_svg(vectors, mode, layer, scale, api, alfa)
	{
		var c = vectors.length;

		var x, y, x2, y2, x3, y3;
		var pts;
		var cc, b, p;
		var shape;
		var pos_x = 0, pos_y = 0;

		if (api_slice)
		{
			pos_x = api_detail_data.pos[0];
			pos_y = api_detail_data.pos[1];
		}

		for (a = 0; a < c; a++)
		{
			g = vectors[a];
			if (!api)
				switch (mode)
				{
					case 1: if (g.c == "#ffffff") continue; break;
					case 2: if (g.c != "#ffffff") continue; break;
					case 3: if (g.g != "bg") return;
				}
			if (g.g == 'r')
			{
				svgz_rect((g.x-pos_x)/scale, (g.y-pos_y)/scale, g.w/scale, g.h/scale, 1, g.c, 1*alfa, 0);
			}
			else
			if (g.g == 't')
			{
				svgz_triangle((g.x-pos_x)/scale, (g.y-pos_y)/scale, g.x2/scale, g.y2/scale, g.x3/scale, g.y3/scale, 1, g.c, 1*alfa, 0);
			}
			else
			if (g.g == 'p')
			{
				var v = new Array();
				for (var key in g)
				{
					if (key[0] == 'x')
					{
						v.push((g[key]-pos_x)/scale);
					}
					else
					if (key[0] == 'y')
					{
						v.push((g[key]-pos_y)/scale);
					}
   				}
					svgz_polygon4(v[0], v[1], v[2], v[3], v[4], v[5], v[6], v[7], 1, g.c, g.a*alfa, 0);
			}
			else
			if (g.g == 'pl')
			{
				svgz_bezier(g.pts, 1, g.c, g.a*alfa, 0, scale, pos_x, pos_y);
			}
   			else
   			if (g.g == 'r_p')
   			{
				shape = shape_def[layer][0];
				svgz_rect((g.x+shape[0]-pos_x)/scale, (g.y+shape[1]-pos_y)/scale, shape[2]/scale, shape[3]/scale, 1, g.c, 1*alfa, 0);
   			}
   			else
   			if (g.g == 'p_p')
   			{
   				svgz_shape_id((g.x-pos_x)/scale, (g.y-pos_y)/scale, (layer*shape_def_size) + g.id, 1, g.c, g.a*alfa, 0);
   			}
			else
   			if (g.g == 'p_pp')
   			{
   				svgz_shape_id((g.x-pos_x)/scale, (g.y-pos_y)/scale, (layer*shape_def_size) + g.id, 1, g.c, g.a*alfa, 0);
   			}
   			else
   			if (g.g == 'bez_p')
   			{
   				svgz_bezier_id((g.x-pos_x)/scale, (g.y-pos_y)/scale, layer, 1, g.c, g.a*alfa, 0);
   			}
   			else
   			if (g.g == 'shl_p')
   			{
				svgz_quadratic_id((g.x-pos_x)/scale, (g.y-pos_y)/scale, (layer*shape_def_size) + g.id, 1, g.c, g.a*alfa, 0);
   			}
   			else
   			if (g.g == 'bg' && ((glass_type != 1 && mode == 3 && !api) || api))
   			{
   				if (!api_slice)
   				{
   					x = g.x/scale;
   					y = g.y/scale;
   					x2 = g.w/scale
   					y2 = g.h/scale;
   				}
   				else
   				{
   					x = g.x - api_detail_data.bleed;
   					y = g.y - api_detail_data.bleed;
   					x2 = api_detail_data.dim[0] + api_detail_data.bleed*2;
   					y2 = api_detail_data.dim[1] + api_detail_data.bleed*2;
   				}
				svgz_rect(x, y, x2, y2, 1, g.c, ((!glass_type ? 1 : 0.6)*alfa) * api_fill_alpha, 0);
			}
			/*else
			if (api)
			{
			if (g.g == 'r_i')
   			{
   				shape_def[layer] = new Array(g.num);
   			}
   			else
   			if (g.g == 'r_o')
   			{
   				shape_def[layer][g.id] = g.pts;
   			}
			}*/

		}
	}

// ------------------------------------------------------------------------------


	function paint_vectors(context_, vectors, canvas_size, out_size_wid, out_size_hei, alfa, cor, index_start, index_end, zoom, layer)
	{
		if (!context_) return;

		var c = vectors.length;

		var a, b, g;
		var x, y, xx, yy, w, h, ww, hh;
		var x2, y2, x3, y3;
		var x_add = 0, y_add = 0;
		var xp, yp;

		var c, cc, p, v;

		var shape;

		var canvas_size_wid, canvas_size_hei;
		var border_left = 0, border_right = canvas_size, border_top = 0, border_bottom = canvas_size;

		var aspect = out_size_wid / out_size_hei;
		if (!zoom)
		{
			canvas_size_wid = canvas_size_hei = canvas_size;

			if (aspect < 1.0)
			{
				x_add = (canvas_size - (canvas_size * aspect))/2;
				canvas_size_wid = canvas_size * aspect;
				canvas_size_hei = canvas_size;
				border_left = x_add;
				border_right = x_add + canvas_size_wid;
			}
			else
			if (aspect > 1.0)
			{
				y_add = (canvas_size - (canvas_size / aspect))/2;
				canvas_size_wid = canvas_size;
				canvas_size_hei = canvas_size / aspect;
				border_top = y_add;
				border_bottom = y_add + canvas_size_hei;
			}
		}
		else
		if (zoom == 1)
		{
			if (!api_slice)
				canvas_size_wid = canvas_size_hei = canvas_size;
			else
			{
				canvas_size_wid = canvas_size;
				canvas_size_hei = Math.ceil((out_size_hei*canvas_size)/out_size_wid);
			}
			//x_add = - (dim_wid-out_size_wid)/2*(canvas_size_wid/out_size_wid);
			//y_add = - (dim_hei-out_size_hei)/2*(canvas_size_hei/out_size_hei);
			x_add = - api_detail_data.pos[0]*(canvas_size_wid/out_size_wid);
			y_add = - api_detail_data.pos[1]*(canvas_size_hei/out_size_hei);
		}
		else
		if (zoom == 2)
		{
			canvas_size_wid = dim_export_wid;
			canvas_size_hei = dim_export_hei;
			border_right = canvas_size_wid;
			border_bottom = canvas_size_hei;
		}

		var scatter_scale = UI.valuef("scatter_scale");

		if (index_start == -1) index_start = 0;
		if (index_end == -1) index_end = c;
		else
		if (index_end > c) index_end = c;

		for (a = index_start; a < index_end; a++)
		{
			g = vectors[a];// if (a%2==0) g.c="#FF8000"; else g.c="black";

			if (g.g == 'r')
			{

			x = x_add + (canvas_size_wid*g.x)/out_size_wid;
			y = y_add + (canvas_size_hei*g.y)/out_size_hei;
			w = (canvas_size_wid*g.w)/out_size_wid;
			h = (canvas_size_hei*g.h)/out_size_hei;
			if (x >= border_right | y >= border_bottom | x + w < border_left | y + h < border_top) continue;

			if (cor)
			{
				xx = Math.floor(x); yy = Math.floor(y);
				if (cor == 1)
				{
					w = w+(x-xx);
					h = h+(y-yy);
				}
				else
				{
					w = Math.floor(w+(x-xx));
					h = Math.floor(h+(y-yy));
				}
				x = xx; y = yy;
			}

			context_.globalAlpha = alfa;
			context_.fillStyle = g.c;
			context_.fillRect(x, y, w, h);

			}
			else
			if (g.g == 'r_i')
   			{
   				shape_def[layer] = new Array(g.num);
   			}
   			else
   			if (g.g == 'r_o')
   			{
   				shape_def[layer][g.id] = g.pts;
   			}
   			else
   			if (g.g == 'r_p')
   			{
   				shape = shape_def[layer][0];
   				if (shape == undefined)
   				{
   					alert("r_p l:"+layer);
   					break;
   				}

   				x = x_add + (canvas_size_wid*(g.x+shape[0]))/out_size_wid;
				y = y_add + (canvas_size_hei*(g.y+shape[1]))/out_size_hei;
				w = (canvas_size_wid*shape[2])/out_size_wid;
				h = (canvas_size_hei*shape[3])/out_size_hei;

				if (cor)
				{
					xx = Math.floor(x); yy = Math.floor(y);
					if (cor == 1)
					{
						w = w+(x-xx);
						h = h+(y-yy);
					}
					else
					{
						w = Math.floor(w+(x-xx));
						h = Math.floor(h+(y-yy));
					}
					x = xx; y = yy;
				}

				context_.globalAlpha = alfa;
				context_.fillStyle = g.c;
				context_.fillRect(x, y, w, h);
			}
			else
			if (g.g == 't')
			{
				x = x_add + (canvas_size_wid*g.x)/out_size_wid;
				y = y_add + (canvas_size_hei*g.y)/out_size_hei;
				x2 = x_add + (canvas_size_wid*g.x2)/out_size_wid;
				y2 = y_add + (canvas_size_hei*g.y2)/out_size_hei;
				x3 = x_add + (canvas_size_wid*g.x3)/out_size_wid;
				y3 = y_add + (canvas_size_hei*g.y3)/out_size_hei;

				context_.globalAlpha = alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();
				context_.moveTo(x, y);
				context_.lineTo(x2, y2);
				context_.lineTo(x3, y3);
				context_.lineTo(x, y);
				context_.globalAlpha = alfa;
				context_.closePath();
				context_.fill();
				context_.lineWidth = 1;
				context_.stroke();
			}
			else
			if (g.g == 'p')
			{

				p = 0;
				v = new Array();
				for (var key in g)
				{
					if (key[0] == 'x')
					{
						x = g[key];
						x = x_add + (canvas_size_wid*x)/out_size_wid;
						v.push(x);
					}
					else
					if (key[0] == 'y')
					{
						y = g[key];
						y = y_add + (canvas_size_hei*y)/out_size_hei;
						v.push(y);
					}
   				}

				context_.globalAlpha = g.a * alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();

   				cc = v.length;
   				for (b = 0; b < cc; b += 2)
   				{
   					if (!b)
   						context_.moveTo(v[b], v[b+1]);
   					else
   						context_.lineTo(v[b], v[b+1]);
   				}
   				context_.lineTo(v[0], v[1]);
   				context_.closePath();
				context_.fill();
				//if (g.a == 1)
				//{
					context_.lineWidth = 1;
					context_.stroke();
				//}
   			}
   			else
   			if (g.g == 'bez_p')
   			{
   				if (shape_def[layer].length == 0) continue;
   				shape = shape_def[layer];
				context_.globalAlpha = g.a * alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();

   				b = 0;
   				x = g.x + shape[b];
   				y = g.y + shape[b+1];
 				x = x_add + (canvas_size_wid*x)/out_size_wid;
  				y = y_add + (canvas_size_hei*y)/out_size_hei;

				cc = shape.length;
				context_.moveTo(x, y);
				b += 2;
				while (b < cc)
				{
   					x = g.x + shape[b];
   					y = g.y + shape[b+1];
   					x = x_add + (canvas_size_wid*x)/out_size_wid;
   					y = y_add + (canvas_size_hei*y)/out_size_hei;
   					x2 = g.x + shape[b+2];
   					y2 = g.y + shape[b+3];
   					x2 = x_add + (canvas_size_wid*x2)/out_size_wid;
   					y2 = y_add + (canvas_size_hei*y2)/out_size_hei;
   					x3 = g.x + shape[b+4];
   					y3 = g.y + shape[b+5];
   					x3 = x_add + (canvas_size_wid*x3)/out_size_wid;
   					y3 = y_add + (canvas_size_hei*y3)/out_size_hei;
					context_.bezierCurveTo(x, y, x2, y2, x3, y3);
					b += 6;
				}

   				context_.closePath();
   				context_.fill();
   			}
   			else
   			if (g.g == 'bez_o')
   			{
   				shape_def[layer] = new Array();
   				shape = shape_def[layer];

   				cc = g.pts.length;
   				b = 0;
   				x = g.pts[b];
   				y = g.pts[b+1];
 				shape.push(x, y);
   				b += 2;

   				while (b < cc)
   				{
   					x = g.pts[b];
   					y = g.pts[b+1];
   					shape.push(x, y);
   					b += 2;
   					x2 = g.pts[b];
   					y2 = g.pts[b+1];
   					shape.push(x2, y2);
   					b += 2;
   					x3 = g.pts[b];
   					y3 = g.pts[b+1];
   					shape.push(x3, y3);
   					b += 2;
   				}
   			}
   			else
   			if (g.g == 'p_i')
   			{
   				shape_def[layer] = new Array(g.num);
   			}
   			else
   			if (g.g == 'p_o')
   			{
   				shape_def[layer][g.id] = g.pts;
   			}
   			else
   			if (g.g == 'p_p')
   			{
   				shape = shape_def[layer][g.id];
   				if (shape == undefined)
   				{
   					alert("p_p l:"+layer+" id:"+g.id);
   					break;
   				}

				context_.globalAlpha = g.a * alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();
   				cc = shape.length;

   				for (b = 0; b < cc; b += 2)
   				{
   					x = shape[b] + g.x;
   					y = shape[b+1] + g.y;

 					x = x_add + (canvas_size_wid*x)/out_size_wid;
  					y = y_add + (canvas_size_hei*y)/out_size_hei;

   					if (!b)
   					{
   						context_.moveTo(x, y);
   						x2 = x; y2 = y;
   					}
   					else
   						context_.lineTo(x, y);
   				}
   				context_.lineTo(x2, y2);
   				context_.closePath();
				context_.fill();
				if (g.a == 1)
				{
					context_.lineWidth = 1;
					context_.stroke();
				}
   			}
   			else
   			if (g.g == 'p_pp')
   			{
   				shape = shape_def[layer][g.id];
   				if (shape == undefined)
   				{
   					alert("p_pp l:"+layer+" id:"+g.id);
   					break;
   				}

				cc = shape.length;
				cc >>= 3;
				p = 0;

				for (c = 0; c < cc; c++)
				{
					context_.globalAlpha = g.a * alfa;
					context_.fillStyle = g.c;
					context_.strokeStyle = g.c;
					context_.beginPath();

   					for (b = 0; b < 4; b++, p += 2)
   					{
   						x = shape[p] + g.x;
   						y = shape[p+1] + g.y;

 						x = x_add + (canvas_size_wid*x)/out_size_wid;
  						y = y_add + (canvas_size_hei*y)/out_size_hei;

   						if (!b)
   						{
   							context_.moveTo(x, y);
	   						x2 = x; y2 = y;
   						}
   						else
   							context_.lineTo(x, y);
   					}
   					context_.lineTo(x2, y2);
   					context_.closePath();
					context_.fill();
					if (g.a == 1)
					{
						context_.lineWidth = 1;
						context_.stroke();
					}
				}
   			}
   			else
   			if (g.g == 'shl_i')
   			{
				shape_def[layer] = new Array(g.num);
			}
   			else
   			if (g.g == 'shl_p')
   			{
   				shape = shape_def[layer][g.id];
   				if (shape == undefined)
   				{
   					alert("shl_p l:"+layer+" id:"+g.id);
   					break;
   				}

				context_.globalAlpha = g.a * alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();
   				cc = shape.length;

   				b = 0;
   				x = shape[b] + g.x;
   				y = shape[b+1] + g.y;
 				x = x_add + (canvas_size_wid*x)/out_size_wid;
  				y = y_add + (canvas_size_hei*y)/out_size_hei;

   				context_.moveTo(x, y);
   				b += 2;

   				while (b < cc)
   				{
   					x = shape[b] + g.x;
   					y = shape[b+1] + g.y;
   					x = x_add + (canvas_size_wid*x)/out_size_wid;
   					y = y_add + (canvas_size_hei*y)/out_size_hei;
   					b += 2;
   					x2 = shape[b] + g.x;
   					y2 = shape[b+1] + g.y;
   					x2 = x_add + (canvas_size_wid*x2)/out_size_wid;
   					y2 = y_add + (canvas_size_hei*y2)/out_size_hei;
   					b += 2;
   					context_.quadraticCurveTo(x, y, x2, y2);
   				}

   				context_.closePath();
   				context_.fill();
   			}
   			else
   			if (g.g == 'shl_o')
   			{
   				shape_def[layer][g.id] = g.pts;
   			}
   			else
   			if (g.g == 'pl')
   			{
				context_.globalAlpha = g.a * alfa;
				context_.fillStyle = g.c;
				context_.strokeStyle = g.c;
				context_.beginPath();
   				cc = g.pts.length;

   				b = 0;
   				x = g.pts[b];
   				y = g.pts[b+1];
 				x = x_add + (canvas_size*x)/out_size;
  				y = y_add + (canvas_size*y)/out_size;
   				context_.moveTo(x, y);
   				b += 2;

   				while (b < cc)
   				{
   					x = g.pts[b];
   					y = g.pts[b+1];
   					x = x_add + (canvas_size*x)/out_size;
   					y = y_add + (canvas_size*y)/out_size;
   					b += 2;
   					x2 = g.pts[b];
   					y2 = g.pts[b+1];
   					x2 = x_add + (canvas_size*x2)/out_size;
   					y2 = y_add + (canvas_size*y2)/out_size;
   					b += 2;
   					x3 = g.pts[b];
   					y3 = g.pts[b+1];
   					x3 = x_add + (canvas_size*x3)/out_size;
   					y3 = y_add + (canvas_size*y3)/out_size;
   					b += 2;
   					context_.bezierCurveTo(x, y, x2, y2, x3, y3);
   				}

   				context_.closePath();
   				context_.fill();
   			}
   			else
			if (g.g == 'bg' && glass_type != 1)
			{
				x = x_add + (canvas_size_wid*g.x)/out_size_wid;
				y = y_add + (canvas_size_hei*g.y)/out_size_hei;
				w = (canvas_size_wid*g.w)/out_size_wid;
				h = (canvas_size_hei*g.h)/out_size_hei;

				context_.globalAlpha = ((!glass_type ? 1 : 0.6) * alfa) * api_fill_alpha;
				context_.fillStyle = g.c;
				context_.fillRect(x, y, w, h);
			}


   		}

   	if (!zoom && aspect != 1.0)
   	{
		context_.globalAlpha = alfa;
		context_.fillStyle = col_black.str;

		if (aspect < 1.0)
		{
			context_.fillRect(0, 0, x_add, canvas_size);
			context_.fillRect(canvas_size - x_add, 0, x_add, canvas_size);
		}
		else
		if (aspect > 1.0)
		{
			context_.fillRect(0, 0, canvas_size, y_add);
			context_.fillRect(0, canvas_size - y_add, canvas_size, y_add);
		}
   	}
   	else
   	if (zoom == 1)
   	{
		context_.globalAlpha = alfa;
		context_.fillStyle = col_black.str;

		if (dim_hei < out_size_hei)
		{
			border_top = (out_size_hei - dim_hei)/2*(canvas_size_hei/out_size_hei);
			context_.fillRect(0, 0, canvas_size_wid, border_top);
			context_.fillRect(0, canvas_size_hei - border_top, canvas_size_wid, border_top);
		}
		if (dim_wid < out_size_wid)
		{
			border_left = (out_size_wid - dim_wid)/2*(canvas_size_wid/out_size_wid);
			context_.fillRect(0, 0, border_left, canvas_size_hei);
			context_.fillRect(canvas_size_wid - border_left, 0, border_left, canvas_size_hei);
		}
   	}
}

// ------------------------------------------------------------------------------
	function save_bin(filename, api, callback, export_layers)
	{
		var scale = 1;
		var stats = new Array();

		if (!image_ready)
		{
			if (api && callback != null) callback(1, null);
			return;
		}

		if (!api_slice && (dim_wid > 200 || dim_hei > 200))
		{
			scale = 10;
			if (dim_wid > 2000 | dim_hei > 2000)
				scale = 100;
		}

		if (!api)
		{
			/*paint_svg_shapes(vectors_l1[0], 0);
			paint_svg_shapes(vectors_l2[0], 1);

			svgz_start(""+(dim_wid/scale).toFixed(3)+"", ""+(dim_hei/scale).toFixed(3)+"");

			paint_svg_defs(vectors_l1[0], scale, 0);

			if (api_layers == 2)
			{
				paint_svg_defs(vectors_l2[0], scale, 1);

				svgz_group_start("colorfill");
				paint_svg(vectors_l1[0], 3,  0, scale, api, 1);
				paint_svg(vectors_l2[0], 3,  1, scale, api, 1);
				svgz_group_end();

				svgz_group_start("layer2");
				paint_svg(vectors_l1[0], 1,  0, scale, api, 1);
				svgz_group_end();

				svgz_group_start("layer1");
				paint_svg(vectors_l2[0], 1,  1, scale, api, 1);
				svgz_group_end();

				svgz_group_start("layer1-white");
				paint_svg(vectors_l2[0], 2,  1, scale, api, 1);
				svgz_group_end();
			}
			else
			{
				svgz_group_start("colorfill");
				paint_svg(vectors_l1[0], 3,  0, scale, api, 1);
				paint_svg(vectors_l2[0], 3,  1, scale, api, 1);
				svgz_group_end();
				svgz_group_start("layer-white");
				paint_svg(vectors_l1[0], 2,  0, scale, api, 1);
				paint_svg(vectors_l2[0], 2,  1, scale, api, 1);
				svgz_group_end();
				svgz_group_start("layer");
				paint_svg(vectors_l1[0], 1,  0, scale, api, 1);
				paint_svg(vectors_l2[0], 1,  1, scale, api, 1);
				svgz_group_end();
			}

			svgz_end();
			saveAs(svgz_data.getBlob(), filename);*/
		}
		else
		{
			if (api == 1)
			{
					shape_def_size = 0;
					paint_svg_shapes(vectors_l1[api_slice], 0);
					paint_svg_shapes(vectors_l2[api_slice], 1);

					bin_start(scale, true);

					var dv = bin_view(8);
					bin_head4(dv, "DEFS");

					dv.setInt32(4, shape_def_size, true);

					paint_bin_defs(vectors_l1[api_slice], scale, 0);

					if (api_layers == 2)
					{
						bin_group_start("layer2", BinGroupNote.None);
						paint_bin(vectors_l1[api_slice], 1,  0, scale, api, 1);
						bin_group_end(); stats.push( {"layer2" : bin_group_items} );
						var bin1 = new Uint8Array(bin_data, 0, bin_data_size);

						bin_start(scale, false);

						var dv = bin_view(8);
						bin_head4(dv, "DEFS");
						dv.setInt32(4, shape_def_size, true);
						shape_def_size = 0;

						paint_bin_defs(vectors_l2[api_slice], scale, 1);
						bin_group_start("layer1", BinGroupNote.None); stats.push( {"layer1" : bin_group_items} );
						paint_bin(vectors_l2[api_slice], 1,  1, scale, api, 1);
						bin_group_end();

						var bin2 = new Uint8Array(bin_data, bin_data_2nd_start, bin_data_size - bin_data_2nd_start);

						if (callback != null) callback(0, bin1, bin2, stats);
					}
					else
					{
						shape_def_size = 0;
						//	paint_bin_defs(vectors_l2[0], scale, 0);
						bin_group_start("layer", BinGroupNote.None);
						paint_bin(vectors_l1[api_slice], 1,  0, scale, api, 1);
						paint_bin(vectors_l2[api_slice], 1,  1, scale, api, 1);
						bin_group_end();  stats.push( {"layer" : bin_group_items} );

						var bin1 = new Uint8Array(bin_data, 0, bin_data_size);

						if (callback != null) callback(0, bin1, null, stats);
					}

			}
			else
			if (api == 2) // two layers - merged version
			{
				shape_def_size = 0;
				paint_svg_shapes(vectors_l1[api_slice], 0);
				paint_svg_shapes(vectors_l2[api_slice], 1);

          		bin_start(scale, true);

				var dv = bin_view(8);
				bin_head4(dv, "DEFS");
				dv.setInt32(4, shape_def_size*(api_layers == 1 ? 1 : 2), true);

				paint_bin_defs(vectors_l1[api_slice], scale, 0);

				if (api_layers == 2)
				{
					paint_bin_defs(vectors_l2[api_slice], scale, 1);

					switch (export_layers)
					{
						case ComponentExportMode.AllLayers: // all layers

          					bin_group_start("Digital White Layer", BinGroupNote.None);

          					paint_bin(vectors_l2[api_slice], 2,  1, scale, 0, 1);

	          				bin_group_end(); stats.push( {"Digital White Layer" : bin_group_items} );

          					bin_group_start("Fill Color", BinGroupNote.None);
							paint_bin(vectors_l1[api_slice], 3,  0, scale, 0, 1);
							paint_bin(vectors_l2[api_slice], 3,  1, scale, 0, 1);
          					bin_group_end(); stats.push( {"Fill Color" : bin_group_items} );

	          				bin_group_start("Bottom Layer", BinGroupNote.None);
          					paint_bin(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          					bin_group_end(); stats.push( {"Bottom Layer" : bin_group_items} );

          					bin_group_start("Top Layer", BinGroupNote.None);
          					paint_bin(vectors_l2[api_slice], 1,  1, scale, 0, 1);
	          				bin_group_end(); stats.push( {"Top Layer" : bin_group_items} );

	          				break;

	          			case ComponentExportMode.TopLayer: // Top Color Layer

          					bin_group_start("Top Layer", BinGroupNote.None);
          					paint_bin(vectors_l2[api_slice], 1,  1, scale, 0, 1);
	          				bin_group_end(); stats.push( {"Top Layer" : bin_group_items} );

	          				break;

	          			case ComponentExportMode.BottomLayer: // Bottom Color Layer

          					bin_group_start("Fill Color", BinGroupNote.None);
							paint_bin(vectors_l1[api_slice], 3,  0, scale, 0, 1);
							paint_bin(vectors_l2[api_slice], 3,  1, scale, 0, 1);
          					bin_group_end(); stats.push( {"Fill Color" : bin_group_items} );

	          				bin_group_start("Bottom Layer", BinGroupNote.None);
          					paint_bin(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          					bin_group_end(); stats.push( {"Bottom Layer" : bin_group_items} );

	          				break;

	          			case ComponentExportMode.TopWhiteLayer:

          					bin_group_start("Digital White 60%", BinGroupNote.None);

          					paint_bin(vectors_l2[api_slice], 2,  1, scale, 0, 1);

	          				bin_group_end(); stats.push( {"Digital White 60%" : bin_group_items} );

          					bin_group_start("Digital White @ 15%", BinGroupNote.DigitalWhiteTop);
          					paint_bin(vectors_l2[api_slice], 1,  1, scale, 0, 1);
	          				bin_group_end(); stats.push( {"Digital White @ 15%" : bin_group_items} );
	          				break;

	          			case ComponentExportMode.BottomWhiteLayer:

	          				bin_group_start("Digital White @ 75%", BinGroupNote.DigitalWhiteBottom);
          					paint_bin(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          					bin_group_end(); stats.push( {"Digital White @ 75%" : bin_group_items} );
	          				break;
	          		}
          		}
          		else  // single layers - merged version
          		{
          			shape_def_size = 0;

          			bin_group_start("Fill Color", BinGroupNote.None);
          			paint_bin(vectors_l1[api_slice], 3,  0, scale, 0, 1);
          			paint_bin(vectors_l2[api_slice], 3,  1, scale, 0, 1);
          			bin_group_end(); stats.push( {"Fill Color" : bin_group_items} );

          			bin_group_start("Digital White Layer", BinGroupNote.None);
					paint_bin(vectors_l1[api_slice], 2,  1, scale, 0, 1);
          			paint_bin(vectors_l2[api_slice], 2,  1, scale, 0, 1);
	          		bin_group_end(); stats.push( {"Digital White Layer" : bin_group_items} );

          			bin_group_start("Color Layer", BinGroupNote.None);
          			paint_bin(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          			paint_bin(vectors_l2[api_slice], 1,  1, scale, 0, 1);
          			bin_group_end(); stats.push( {"Color Layer" : bin_group_items} );
          		}

          		var bin = new Uint8Array(bin_data, 0, bin_data_size);
          		if (callback != null) callback(0, bin, null, stats);
			}
		}
	}

	function save_svg(filename, api, callback, export_layers)
	{
		var scale = 1;
		var stats = new Array();

		if (!image_ready)
		{
			if (api && callback != null) callback(1, null);
			return;
		}

		if (!api_slice && (dim_wid > 200 || dim_hei > 200))
		{
			scale = 10;
			if (dim_wid > 2000 || dim_hei > 2000)
				scale = 100;
		}

		if (!api)
		{
			paint_svg_shapes(vectors_l1[api_slice], 0);
			paint_svg_shapes(vectors_l2[api_slice], 1);

			svgz_start(scale);

			paint_svg_defs(vectors_l1[api_slice], scale, 0);

			if (api_layers == 2)
			{
				paint_svg_defs(vectors_l2[api_slice], scale, 1);

				svgz_group_start("colorfill");
				paint_svg(vectors_l1[api_slice], 3,  0, scale, api, 1);
				paint_svg(vectors_l2[api_slice], 3,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"colorfill" : svgz_shapes} );

				svgz_group_start("layer2");
				paint_svg(vectors_l1[api_slice], 1,  0, scale, api, 1);
				svgz_group_end(); stats.push( {"layer2" : svgz_shapes} );

				svgz_group_start("layer1");
				paint_svg(vectors_l2[api_slice], 1,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"layer1" : svgz_shapes} );

				svgz_group_start("layer1-white");
				paint_svg(vectors_l2[api_slice], 2,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"layer1-white" : svgz_shapes} );
			}
			else
			{
				shape_def_size = 0;

				svgz_group_start("colorfill");
				paint_svg(vectors_l1[api_slice], 3,  0, scale, api, 1);
				paint_svg(vectors_l2[api_slice], 3,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"colorfill" : svgz_shapes} );
				svgz_group_start("layer-white");
				paint_svg(vectors_l1[api_slice], 2,  0, scale, api, 1);
				paint_svg(vectors_l2[api_slice], 2,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"layer-white" : svgz_shapes} );
				svgz_group_start("layer");
				paint_svg(vectors_l1[api_slice], 1,  0, scale, api, 1);
				paint_svg(vectors_l2[api_slice], 1,  1, scale, api, 1);
				svgz_group_end(); stats.push( {"layer" : svgz_shapes} );
			}

		//blob = new Blob([ svgz_end() ], { type: "image/svg" } );
			svgz_end();
			saveAs(svgz_data.getBlob(), filename);
		}
		else
		{
			if (api == 1)
			{
					paint_svg_shapes(vectors_l1[api_slice], 0);
					paint_svg_shapes(vectors_l2[api_slice], 1);

					svgz_start(scale);
					paint_svg_defs(vectors_l1[api_slice], scale, 0);

					if (api_layers == 2)
					{
						svgz_group_start("layer2");
						paint_svg(vectors_l1[api_slice], 1,  0, scale, api, 1);
						svgz_group_end();
						svgz_end(); stats.push( {"layer2" : svgz_shapes} );
						var svg1 = svgz_data.getBlob();

						svgz_start(scale);
						paint_svg_defs(vectors_l2[api_slice], scale, 1);
						svgz_group_start("layer1");
						paint_svg(vectors_l2[api_slice], 1,  1, scale, api, 1);
						svgz_group_end();
						svgz_end(); stats.push( {"layer1" : svgz_shapes} );
						var svg2 = svgz_data.getBlob();

						if (callback != null) callback(0, svg1, svg2, stats);
					}
					else
					{
						shape_def_size = 0;

						svgz_group_start("layer");
						paint_svg(vectors_l1[api_slice], 1,  0, scale, api, 1);
						//paint_svg_defs(vectors_l2[0], scale, 0);
						paint_svg(vectors_l2[api_slice], 1,  1, scale, api, 1);
						svgz_group_end();
						svgz_end(); stats.push( {"layer" : svgz_shapes} );
						var svg = svgz_data.getBlob();

						if (callback != null) callback(0, svg, null, stats);
					}

			}
			else
			if (api == 2)
			{
				paint_svg_shapes(vectors_l1[api_slice], 0);
				paint_svg_shapes(vectors_l2[api_slice], 1);

          		svgz_start(scale);

				paint_svg_defs(vectors_l1[api_slice], scale, 0);

				if (api_layers == 2)
				{
					paint_svg_defs(vectors_l2[api_slice], scale, 1);

          			svgz_group_start("layer1-white");

          			paint_svg(vectors_l2[api_slice], 2,  1, scale, 0, 1);

	          		svgz_group_end(); stats.push( {"layer1-white" : svgz_shapes} );

          			svgz_group_start("colorfill");
          			paint_svg(vectors_l1[api_slice], 3,  0, scale, 0, 1);
          			paint_svg(vectors_l2[api_slice], 3,  1, scale, 0, 1);
          			svgz_group_end(); stats.push( {"colorfill" : svgz_shapes} );

          			svgz_group_start("layer2");
          			paint_svg(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          			svgz_group_end(); stats.push( {"layer2" : svgz_shapes} );

          			svgz_group_start("layer1");
          			paint_svg(vectors_l2[api_slice], 1,  1, scale, 0, 1);
	          		svgz_group_end(); stats.push( {"layer1" : svgz_shapes} );
          		}
          		else
          		{
          			shape_def_size = 0;

          			svgz_group_start("colorfill");
          			paint_svg(vectors_l1[api_slice], 3,  0, scale, 0, 1);
          			paint_svg(vectors_l2[api_slice], 3,  1, scale, 0, 1);
          			svgz_group_end(); stats.push( {"colorfill" : svgz_shapes} );

          			svgz_group_start("layer-white");
					paint_svg(vectors_l1[api_slice], 2,  1, scale, 0, 1);
          			paint_svg(vectors_l2[api_slice], 2,  1, scale, 0, 1);
	          		svgz_group_end(); stats.push( {"layer-white" : svgz_shapes} );

          			svgz_group_start("layer");
          			paint_svg(vectors_l1[api_slice], 1,  0, scale, 0, 1);
          			paint_svg(vectors_l2[api_slice], 1,  1, scale, 0, 1);
          			svgz_group_end(); stats.push( {"layer" : svgz_shapes} );
          		}

          		svgz_end();
          		var svg = svgz_data.getBlob();
          		if (callback != null) callback(0, svg, null, stats);
			}
		}
	}

// -----------------------

	function grab_image()
	{
		var scale = (dim_bmp*img_scale)/100;
		var scale2 = (dim_bmp*(img_y_res/img_x_res)*img_scale)/100;

		canvas_bitmap.width = dim_bmp;
		canvas_bitmap.height = dim_bmp;
		if (typeof pf_nodejs === "undefined")
		{
			canvas_bitmap.style.width = dim_bmp;
			canvas_bitmap.style.height = dim_bmp;
		}

		context_bitmap.globalAlpha = 1;
		context_bitmap.drawImage(image, -(img_x_res-dim_bmp)/2-scale/2, -(img_y_res-dim_bmp)/2-scale2/2, img_x_res+scale, img_y_res+scale2);
		var imageData = context_bitmap.getImageData(0, 0, dim_bmp, dim_bmp);
		image_data = imageData.data;

		var a;
		for (a = 0; a < dim_bmp*dim_bmp*4; a += 4)
		{
			if (image_data[a] >= 254 && image_data[a+1] >= 254 && image_data[a+2] >= 254)
			{
				image_data[a] = image_data[a+1] = image_data[a+2] = 255;
			}
		}

		image_ready = 0;

		if (typeof pf_nodejs === "undefined")
		{
			worker1[0].postMessage({cmd:'bitmap',image_data:image_data,x_res:x_res,y_res:y_res});
			worker2[0].postMessage({cmd:'bitmap',image_data:image_data,x_res:x_res,y_res:y_res});
			worker1[1].postMessage({cmd:'bitmap',image_data:image_data,x_res:x_res,y_res:y_res});
			worker2[1].postMessage({cmd:'bitmap',image_data:image_data,x_res:x_res,y_res:y_res});
		}
		else
		{
			if (pf_nodejs_mth)
			{
				var image_send = new Array(dim_bmp*dim_bmp*4);

				for (a = 0; a < dim_bmp*dim_bmp*4; a += 4)
				{
					image_send[a] = image_data[a];
					image_send[a+1] = image_data[a+1];
					image_send[a+2] = image_data[a+2];
				}
				worker1[0].postMessage({cmd:'bitmap',image_data:image_send,x_res:x_res,y_res:y_res});
				worker2[0].postMessage({cmd:'bitmap',image_data:image_send,x_res:x_res,y_res:y_res});
				worker1[1].postMessage({cmd:'bitmap',image_data:image_send,x_res:x_res,y_res:y_res});
				worker2[1].postMessage({cmd:'bitmap',image_data:image_send,x_res:x_res,y_res:y_res});
			}
			else
				image_ready = 4;
		}
	}

// -----------------------
/*
	var tab_colhex = new Array(256);

	function color_precalc_colhex()
	{
		var a;

		for (a = 0; a < 256; a++)
			tab_colhex[a] = (a < 16 ? '0' : '') + a.toString(16);
	}
	*/
	color_precalc();
	color_precalc_colhex();
	scatter_init_new();

/*
	function color_adjust(r, g, b)
	{
		return '#'+tab_colhex[r]+tab_colhex[g]+tab_colhex[b];
	}

	var colors = { fill: 0 };
	*/
	function colors_update()
	{
		colors.fill = img_fill_color;
		var data = { cmd:'colors', brt: UI.value("col_brt"), con:UI.value("col_con"), cast:UI.value("col_cast"), sat:UI.value("col_sat"), fill:img_fill_color, cast_color:img_cast_color };
		if (typeof pf_nodejs === "undefined" || pf_nodejs_mth)
		{
			worker1[0].postMessage(data);
			worker2[0].postMessage(data);

			//if (typeof pf_nodejs === "undefined")
			{
				worker1[1].postMessage(data);
				worker2[1].postMessage(data);
			}
		}
		else
		{
			colors.brt = data.brt;
			colors.con = data.con;
			colors.sat = data.sat;
			colors.fill = data.fill;
			colors.cast = data.cast;
			colors.cast_color = data.cast_color;
			color_precalc_warmth();
		}
	}

// ---------------------------------


var layer1_img, layer2_img;


var api_bitmap_img;

function save_layer_finish()
{
	image_saving.layer2_ready = 1;

	context_bitmap.setTransform(1, 0, 0, 1, 0, 0);
	context_bitmap.beginPath();
	context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);

	context_bitmap.globalAlpha = 1;
	context_bitmap.drawImage(layer2_img, 0, 0);

	if (api_bitmap_callback != null)
	{
		api_bitmap_img = new Image();
		api_bitmap_img.src = canvas_bitmap.toDataURL("image/raw");
		api_bitmap_img.onload = function func() { api_bitmap_callback(0, api_bitmap_img); api_bitmap_callback = null; };
		api_bitmap_img.noerror = function func() { api_bitmap_callback(1, null); api_bitmap_callback = null; };
	}
	else
		canvas_bitmap.toBlob(function(blob) { saveAs(blob, "output.png"); }, "image/png");

	image_saving.saving = 0;
}

function save_layer2_finish()
{
	image_saving.layer2_ready = 1;

	context_bitmap.setTransform(1, 0, 0, 1, 0, 0);
	context_bitmap.beginPath();
	/*context_bitmap.rect(0, 0, dim_export_wid, dim_export_hei);
	context_bitmap.fillStyle = "white";
	context_bitmap.globalAlpha = 1;
	context_bitmap.fill();*/
	context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);

	context_bitmap.globalAlpha = !glass_type ? 1 : 0.8;
	context_bitmap.drawImage(layer1_img, 0, 0);
	context_bitmap.globalAlpha = 0.6;
	context_bitmap.drawImage(layer2_img, 0, 0);

	if (api_bitmap_callback != null)
	{
		api_bitmap_img = new Image();
		api_bitmap_img.src = canvas_bitmap.toDataURL("image/raw");
		api_bitmap_img.onload = function func() { api_bitmap_callback(0, api_bitmap_img); api_bitmap_callback = null; };
		api_bitmap_img.noerror = function func() { api_bitmap_callback(1, null); api_bitmap_callback = null; };
	}
	else
		canvas_bitmap.toBlob(function(blob) { saveAs(blob, "output.png"); }, "image/png");

	image_saving.saving = 0;
}

function save_layer1_finish()
{
	image_saving.layer1_ready = 1;

	context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);
}

var image_saving = { saving: 0, layer: 0, step: 0, layer1_ready:0, layer2_ready:0 };

var dim_export_wid;
var dim_export_hei;
function save_layers_start(type, size)
{
	var sc;
	switch (type)
	{
		case 0: sc = 576; break;
		case 1: sc = 1152; break;
		case 2: sc = size; break;
	}

	var aspect = dim_wid/dim_hei;
	if (dim_wid > dim_hei)
	{
		dim_export_wid = sc;
		dim_export_hei = Math.floor(sc/aspect);
	}
	else
	{
		dim_export_wid = Math.floor(sc*aspect);
		dim_export_hei = sc;
	}

	canvas_bitmap.width = dim_export_wid;
	canvas_bitmap.height = dim_export_hei;
	canvas_bitmap.style.width = dim_export_wid;
	canvas_bitmap.style.height = dim_export_hei;
	context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);

	image_saving.saving =  1;
	image_saving.layer = image_saving.step = 0;
	image_saving.layer1_ready = image_saving.layer2_ready = 0;
}

function save_node_layers(type, detail, size)
{
	if (!detail)
	{
		if (type != 3) // DPI
		{
			var sc;
			switch (type)
			{
				case 0: sc = 576; break;
				case 1: sc = 1152; break;
				case 2: sc = size; break;
			}

			var aspect = dim_wid/dim_hei;
			if (dim_wid > dim_hei)
			{
				dim_export_wid = sc;
				dim_export_hei = Math.floor(sc/aspect);
			}
			else
			{
				dim_export_wid = Math.floor(sc*aspect);
				dim_export_hei = sc;
			}
		}
		else
		{
			dim_export_wid = Math.floor(dim_wid * size);
			dim_export_hei = Math.floor(dim_hei * size);
		}
	}
	else
	if (api_slice)
	{
		if (type != 3) // DPI
		{
			var sc;
			switch (type)
			{
				case 0: sc = 576; break;
				case 1: sc = 1152; break;
				case 2: sc = size; break;
			}

			dim_export_wid = sc;
			dim_export_hei = Math.ceil((api_detail_data.dim[1]*sc)/api_detail_data.dim[0]);
		}
		else
		{
			dim_export_wid = Math.ceil(api_detail_data.dim[0] * size);
			dim_export_hei = Math.ceil(api_detail_data.dim[1] * size);
		}
	}
	else
	{
		dim_export_wid = 1024;
		dim_export_hei = 1024;
	}

	canvas_bitmap.width = dim_export_wid;
	canvas_bitmap.height = dim_export_hei;
// layer 1
	//if (!detail || (type == 0 || type == 1))
	{
		context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);
		if (!detail)
			paint_vectors(context_bitmap, vectors_l1[api_slice], 0, dim_wid, dim_hei, 1, 2, -1, -1, 2, 0);
		else
		{
			//glass_type = (type == 0) ? 0 : 1;
			paint_vectors(context_bitmap, vectors_l1[api_slice], dim_export_wid, api_detail_data.dim[0], api_detail_data.dim[1], 1, 1, -1, -1, 1, 0);
			//glass_type = 0;
		}
		layer1_img = new Image();
		layer1_img.src = canvas_bitmap.toDataURL("image/raw");
	}
// layer 2
	//if (!detail || (type == 0 || type == 2))
	{
		context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);
		if (!detail)
			paint_vectors(context_bitmap, vectors_l2[api_slice], 0, dim_wid, dim_hei, 1, 2, -1, -1, 2, 1);
		else
		{
			//glass_type = (type == 0) ? 0 : 1;
			paint_vectors(context_bitmap, vectors_l2[api_slice], dim_export_wid, api_detail_data.dim[0], api_detail_data.dim[1], 1, 1, -1, -1, 1, 1);
			//glass_type = 0;
		}
		layer2_img = new Image();
		layer2_img.src = canvas_bitmap.toDataURL("image/raw");
	}
// composite
	context_bitmap.setTransform(1, 0, 0, 1, 0, 0);
	context_bitmap.clearRect(0, 0, dim_export_wid, dim_export_hei);

	//if (!detail || (type == 0 || type == 1) || api_layers == 1)
	{
		context_bitmap.globalAlpha = !glass_type ? 1 : 0.8;
		context_bitmap.drawImage(layer1_img, 0, 0);
	}
	//if (!detail || (type == 0 || type == 2) || api_layers == 1)
	{
		if (api_layers == 2)
		{
			context_bitmap.globalAlpha = 0.6;
			context_bitmap.drawImage(layer2_img, 0, 0);
		}
		else
		{
			context_bitmap.drawImage(layer2_img, 0, 0);
		}
	}

	if (api_bitmap_callback != null)
	{
		api_bitmap_img = new Image();
		api_bitmap_img.src = canvas_bitmap.toDataURL("image/raw");
		api_bitmap_callback(0, api_bitmap_img); api_bitmap_callback = null;
		api_bitmap_img.noerror = function func() { api_bitmap_callback(1, null); api_bitmap_callback = null; };
	}
}

function save_layers_progress()
{
	var l;
	var si, ei;

	if (image_saving.layer == 2) return;

	si = image_saving.step*5000;
	ei = (image_saving.step + 1)*5000;

	if (!image_saving.layer)
	{
		l = vectors_l1[0].length;

		paint_vectors(context_bitmap, vectors_l1[0], 0, dim_wid, dim_hei, 1, 2, si, ei, 2, 0);

		if (ei >= l)
		{
			if (api_layers == 2)
			{
				layer1_img = new Image();
				layer1_img.src = canvas_bitmap.toDataURL("image/raw");
				layer1_img.onload = function func() { save_layer1_finish(); };
			}
			else
				image_saving.layer1_ready = 1;

			image_saving.layer++;
			image_saving.step = 0;
		}
		else
			image_saving.step++;
	}
	else
	if (image_saving.layer == 1)
	{
		if (!image_saving.layer1_ready) return;

		l = vectors_l2[0].length;

		paint_vectors(context_bitmap, vectors_l2[0], 0, dim_wid, dim_hei, 1, 2, si, ei, 2, 1);

		if (ei >= l)
		{
			layer2_img = new Image();
			layer2_img.src = canvas_bitmap.toDataURL("image/raw");
			if (api_layers == 2)
				layer2_img.onload = function func() { save_layer2_finish(); };
			else
				layer2_img.onload = function func() { save_layer_finish(); };

			image_saving.layer++;
		}
		else
			image_saving.step++;
	}
}

// ---------------------------------

function UI_change_eval(id, val, min, max)
{
	var shpz;
	var w, h, s, sp, dist, b, bb, f_dist, cor, t, v, b, bdist;
	var mul = api_layers == 2 ? 1 : 8;

	switch(fx_selected)
	{
		case FX_PIXFLD:
			if (id == 'pf_width')
			{
				s = UI.value("pf_shape");
				do {
					w = (val * s) / 100;
			 		shpz = Math.floor((dim_wid / w) * (dim_hei / val) * 2);
					if (shpz > 3000000*mul)
					{
						val += 0.001;
					}
				} while(shpz > 3000000*mul);
			}
			else
			if (id == 'pf_shape')
			{
				UI.eval_val('pf_width');
			}

			break;

		case FX_IKAT:
			if (id == 'ikat_width')
			{
				w = val;
				s = UI.value("ikat_shape");
				sp = UI.value("ikat_spacing");
				f_dist = Math.sqrt(dim_wid*dim_wid + dim_hei*dim_hei);
				do {
					dist = ((w * 200) * s) / 100;
					b = Math.ceil(f_dist / dist); b++;
					bb = Math.ceil(f_dist / (w + ((w * sp)/200) ));
					shpz = b*bb*2;
					if (shpz > 2500000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 2500000*mul);

				val = w;
			}
			else
			if (id == "ikat_shape")
			{
				UI.eval_val('ikat_width');
			}
			else
			if (id == "ikat_spacing")
			{
				UI.eval_val('ikat_width');
			}

			break;

		case FX_STRIPE:
			if (id == 'stripe_width')
			{
				w = val;
				s = UI.value("stripe_variation");
				f_dist = Math.sqrt(dim_wid*dim_wid + dim_hei*dim_hei);
				do {
					bb = Math.ceil(f_dist / ((w * (s*0.5))/100) );
					shpz = Math.floor(bb*1.75);
					if (shpz > 200000*mul)
					{
						w += 0.01;
					}
				} while(shpz > 200000*mul);

				val = w;
			}
			else
			if (id == "stripe_variation")
			{
				UI.eval_val('stripe_width');
			}

			break;

		case FX_GLACIER:
			if (id == 'glacier_width')
			{
				w = val;
				do {
					h = w*0.25;
			 		shpz = Math.floor((dim_hei / w) * (dim_wid / h) * 2.5);
					if (shpz > 375000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 375000*mul);

				val = w;
			}
			break;

		case FX_CRIMP:
			if (id == 'crimp_size')
			{
				w = val;
				f_dist = Math.sqrt(dim_wid*dim_wid + dim_hei*dim_hei);
				do {
					h = w * 100/0.8;
					b = Math.ceil(f_dist / w);
					bb = Math.ceil(f_dist / h); bb++;
					shpz = b*bb;
					if (shpz > 200000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 200000*mul);

				val = w;
			}
			break;

		case FX_THATCH:
			if (id == 'thatch_width')
			{
				w = val;
				s = UI.value("thatch_shape");
				sp = UI.value("thatch_spacing");
				f_dist = Math.sqrt(dim_wid*dim_wid + dim_hei*dim_hei);
				do {
					dist = ((w * 200) * s) / 100;
					b = Math.ceil(f_dist / dist); b++;
					bb = Math.ceil(f_dist / (w + ((w * sp)/200) ));
					shpz = b*bb*0.6; //*(0.8+0.6);
					if (shpz > 350000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 350000*mul);

				val = w;
			}
			else
			if (id == "thatch_shape")
			{
				UI.eval_val('thatch_width');
			}
			else
			if (id == "thatch_spacing")
			{
				UI.eval_val('thatch_width');
			}

			break;

		case FX_CAIRO:
			if (id == 'cairo_size')
			{
				w = val;
				f_dist = Math.sqrt(dim_wid*dim_wid + dim_hei*dim_hei);
				cor = (dim_proj * (dim_wid < dim_hei ? dim_wid : dim_hei))/(dim_proj*dim_proj);
				cor += 0.1; if (cor > 1.0) cor = 1;
				do {
					dist = (w * 4/100)*50;
					b = (f_dist / dist); b++;
					bb = (f_dist / (w * 4/100) ); b++;
					shpz = b*bb*2*cor;
					if (shpz > 900000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 900000*mul);

				val = w;
			}
			break;

		case FX_SCATTER:
			if (id == 'scatter_scale')
			{
				w = val;
				s = UI.value("scatter_spacing");
				do {
					dist = w*(s/100);
			 		shpz = Math.floor((dim_wid / dist) * (dim_hei / dist) * 1.6);
					if (shpz > 500000*mul)
					{
						w += 0.001;
					}
				} while(shpz > 500000*mul);

				val = w;
			}
			else
			if (id == 'scatter_spacing')
			{
				UI.eval_val('scatter_scale');
			}
			break;

		case FX_ZAG:
			if (id == 'zag_thickness')
			{
				t = val;
				w = UI.valuef('zag_width');
				v = UI.valuef('zag_variation');
				h = UI.valuef('zag_height');
				do {
					dist = t - (t * (0.5 * v)) / 101;
			 		shpz = Math.floor((dim_wid / w) * (dim_hei / dist) * 2.6);
					if (shpz > 400000*mul)
					{
						t = t * 1.001;
						w = w * 1.001;
						h = h * 1.001;
					}
				} while(shpz > 400000*mul);

				val = t;
				UI.setValue('zag_width', w);
				UI.setValue('zag_height', h);
			}
			else
			if (id == 'zag_width')
			{
				UI.eval_val('zag_thickness');
			}
			else
			if (id == 'zag_variation')
			{
				UI.eval_val('zag_thickness');
			}
			break;

		case FX_SEQUENCE:
			if (id == 'sequence_width')
			{
				w = val;
				h = UI.valuef('sequence_height');
				v = UI.value('sequence_variation');
				b = UI.value('sequence_break');

				do {
					bdist = h + ( (h * b) / 100 );
					dist = (w * (0.5 * v)) / 100;
			 		shpz = Math.floor((dim_wid / dist) * (dim_hei / bdist) * 2);
					if (shpz > 500000*mul)
					{
						w += 0.001;
					}

				} while(shpz > 500000*mul);

				val = w;
			}
			else
			if (id == 'sequence_height')
			{
				UI.eval_val('sequence_width');
			}
			else
			if (id == 'sequence_variation')
			{
				UI.eval_val('sequence_width');
			}
			else
			if (id == 'sequence_break')
			{
				UI.eval_val('sequence_width');
			}
			break;
		case FX_ICE:
			if (id == 'ice_scale')
			{
				s = UI.value("ice_shape");
				sp = UI.value("ice_spacing")/100;
				do {
					w = (val*sp * s*sp) / 100;
			 		shpz = Math.floor((dim_wid / w) * (dim_hei / val) * 2);
					if (shpz > 3000000*mul)
					{
						val += 0.001;
					}
				} while(shpz > 3000000*mul);
			}
			else
			if (id == 'ice_shape')
			{
				UI.eval_val('ice_scale');
			}
			else
			if (id == 'ice_spacing')
			{
				UI.eval_val('ice_scale');
			}
			break;
		case FX_CAPE:
			if (id == 'cape_scale')
			{
				h = val * 0.15;
				do {
					w = val * h;
			 		shpz = Math.floor((dim_wid / w) * (dim_hei / val) * 2);
					if (shpz > 3000000*mul)
					{
						val += 0.001;
					}
				} while(shpz > 3000000*mul);
			}
			break;
	}
	return val;
}

// ---

	function paint_views(detail)
	{
		if (worker_paint_start[detail])
		{
			canvas_clearup(detail);
			worker_paint_start[detail] = 0;
		}

		var si1, ei1, si2, ei2;
		var pt1 = 1, pt2 = 1;

		if (worker_paint_steps[detail][0] > 0)
		{
			si1 = worker_paint_step[detail][0] * 5000;
			if (worker_paint_steps[detail][0] == 1)
				ei1 = -1;
			else
				ei1 = (worker_paint_step[detail][0]+1)*5000;
			if (api_layers == 1) pt2 = 0;
		}

		if (worker_paint_steps[detail][1] > 0 && (api_layers == 2 || (api_layers == 1 && !worker_paint_steps[detail][0])))
		{
			si2 = worker_paint_step[detail][1] * 5000;
			if (worker_paint_steps[detail][1] == 1)
				ei2 = -1;
			else
				ei2 = (worker_paint_step[detail][1]+1)*5000;
			if (api_layers == 1) pt1 = 0;
		}

/*
debug view - 12" detail big
		paint_vectors(context[2], vectors_l1, 673, 12, 1, 1, si, ei,   1, 0);
		paint_vectors(context[3], vectors_l2, 673, 12, 1, 1, si, ei,   1, 1);

		paint_vectors(context[0], vectors_l1, 512, dim_proj, 1, 1, si, ei,   0, 0);
		paint_vectors(context[1], vectors_l2, 512, dim_proj, 1, 1, si, ei,   0, 1);
*/
		var c1, c2;
		if (!detail)
		{
			c1 = 2; c2 = 3;
			if (api_layers == 1) c2 = 2;
			if (pt1 && worker_paint_steps[detail][0] > 0)
				paint_vectors(api_context[c1], vectors_l1[detail], api_canvas[2].width, dim_wid, dim_hei, 1, 1, si1, ei1,   0, 0);
			if (pt2 && worker_paint_steps[detail][1] > 0)
				paint_vectors(api_context[c2], vectors_l2[detail], api_canvas[3].width, dim_wid, dim_hei, 1, 1, si2, ei2,   0, 1);
		}
		else
		{
			c1 = 0; c2 = 1;
			if (api_layers == 1) c2 = 0;
			if (pt1 && worker_paint_steps[detail][0] > 0)
				paint_vectors(api_context[c1], vectors_l1[detail], api_canvas[0].width, api_detail_data.dim[0], api_detail_data.dim[1], 1, 1, si1, ei1,   1, 0+2);
			if (pt2 && worker_paint_steps[detail][1] > 0)
				paint_vectors(api_context[c2], vectors_l2[detail], api_canvas[1].width, api_detail_data.dim[0], api_detail_data.dim[1], 1, 1, si2, ei2,   1, 1+2);
		}

		if (pt1 && worker_paint_steps[detail][0] > 0)
		{
			worker_paint_step[detail][0]++;
			worker_paint_steps[detail][0]--;
		}
		if (pt2 && worker_paint_steps[detail][1] > 0)
		{
			worker_paint_step[detail][1]++;
			worker_paint_steps[detail][1]--;
		}

		if (!worker_paint_steps[detail][0] && !worker_paint_steps[detail][1])
		{
			worker_paint[detail] = 0;
			worker_start[detail] = -1;

			if (api_detail_callback)
			{
				api_detail_callback(0, 0);
				api_detail_callback = null;
			}
		}
	}

	function canvas_clearup(detail)
	{
		if (!detail)
		{
			api_context[2].clearRect(0, 0, api_canvas[2].width, api_canvas[2].height);
			api_context[2].setTransform(1, 0, 0, 1, 0, 0);
			api_context[2].beginPath();
			api_context[2].rect(0, 0, api_canvas[2].width, api_canvas[2].height);
			api_context[2].fillStyle = "rgba(255,255,255,0)";
			api_context[2].globalAlpha = 1;
			api_context[2].fill();

			api_context[3].clearRect(0, 0, api_canvas[3].width, api_canvas[3].height);
			api_context[3].setTransform(1, 0, 0, 1, 0, 0);
			api_context[3].beginPath();
			api_context[3].rect(0, 0, api_canvas[3].width, api_canvas[3].height);
			api_context[3].fillStyle = "rgba(255,255,255,0)";
			api_context[3].globalAlpha = 1;
			api_context[3].fill();
		}
		else
		{
			api_context[0].clearRect(0, 0, api_canvas[0].width, api_canvas[0].height);
			api_context[0].setTransform(1, 0, 0, 1, 0, 0);
			api_context[0].beginPath();
			api_context[0].rect(0, 0, api_canvas[0].width, api_canvas[0].height);
			api_context[0].fillStyle = "rgba(255,255,255,0)";
			api_context[0].globalAlpha = 1;
			api_context[0].fill();

			api_context[1].clearRect(0, 0, api_canvas[1].width, api_canvas[1].height);
			api_context[1].setTransform(1, 0, 0, 1, 0, 0);
			api_context[1].beginPath();
			api_context[1].rect(0, 0, api_canvas[1].width, api_canvas[1].height);
			api_context[1].fillStyle = "rgba(255,255,255,0)";
			api_context[1].globalAlpha = 1;
			api_context[1].fill();
		}
	}

// ---

	function new_detail()
	{
		vectors_l1[1].length = 0;
		vectors_l2[1].length = 0;
		workers_request_filtering(1);
	}

	function new_frame(detail)
	{
		if (dim_new) dim_apply();

		vectors_l1[detail].length = 0;
		vectors_l2[detail].length = 0;

		val_change = 0;
		worker_done[detail] = 0;
		worker_detail = detail;

		if (detail)
		{
			worker_full_pending = 1;
			worker_full_pending_time = time;
		}
		else
		{
			worker_full_pending = 0;
		}

		workers_request_filtering(detail);

		worker_start[detail] = (new Date()).getTime();
	}

	function new_node_frame()
	{
		if (dim_new) dim_apply();

		vectors_l1[0].length = 0;
		vectors_l2[0].length = 0;

		request_node_filtering();
	}

	function new_threaded_node_frame(slice, pos, dim, bleed)
	{
		if (dim_new) dim_apply();

		api_slice = slice;
		if (slice)
		{
			api_detail_data.pos = pos;
			api_detail_data.dim = dim;
			api_detail_data.bleed = bleed;
		}

		vectors_l1[slice].length = 0;
		vectors_l2[slice].length = 0;

		workers_request_filtering(slice);
	}

	function workers_request_filtering(detail) // detail=slice
	{
		var filter2_step = UI.valuef("ikat_width")*100/8;
		var filter3_step = UI.valuef("stripe_width") * 0.3;
		var filter5_step = UI.valuef("crimp_size") * 100/0.8;
		var filter6_step = UI.valuef("thatch_width")*100/8;

		var l1 = 0, l2 = 1;
		if (api_layers == 1)
		{
			l1 = 2; l2 = 3;
		}
		var l = api_layers;

		switch (fx_selected)
		{
			case FX_PIXFLD:
				worker1[detail].postMessage({ cmd:'render', filter: FX_PIXFLD, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, pixel_size:UI.valuef("pf_width"), pixel_shape:UI.value("pf_shape"), pixel_disp:0, pixel_rand:UI.value("pf_rnd1"), rotation:UI.value("pf_rotation"), shift_x:0, shift_y:0 });
				break;
			case FX_IKAT:
				worker1[detail].postMessage({ cmd:'render', filter: FX_IKAT, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, step_start:filter2_step/2, step:filter2_step, width:UI.valuef("ikat_width"), shape:UI.value("ikat_shape"), spacing:UI.value("ikat_spacing"), rotation:UI.value("ikat_rotation"), rand_dist:UI.value("ikat_rnd1") });
				break;
			case FX_STRIPE:
				worker1[detail].postMessage({ cmd:'render', filter: FX_STRIPE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, offset:0 , width:UI.valuef("stripe_width"), variation:UI.value("stripe_variation"), coverage:100, rotation:UI.value("stripe_rotation"), rnd:UI.value("stripe_rnd1") });
				break;
			case FX_GLACIER:
				worker1[detail].postMessage({ cmd:'render', filter: FX_GLACIER, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, width:UI.valuef("glacier_width"), coverage:100, rotation:UI.valuef("glacier_rotation"), rnd:UI.value("glacier_rnd1") });
				break;
			case FX_CRIMP:
				worker1[detail].postMessage({ cmd:'render', filter: FX_CRIMP, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, step:filter5_step, width:UI.valuef("crimp_size"), wave:UI.valuef("crimp_wave"), coverage:95, rotation:UI.value("crimp_rotation"), rand_dist:UI.value("crimp_rnd1") });
				break;
			case FX_THATCH:
				worker1[detail].postMessage({ cmd:'render', filter: FX_THATCH, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, step_start:filter6_step/2, step:filter6_step, width:UI.valuef("thatch_width"), shape:UI.value("thatch_shape"), spacing:UI.valuef("thatch_spacing"), coverage:80, rotation:UI.value("thatch_rotation"), rand_dist:UI.value("thatch_rnd1") });
				break;
			case FX_CAIRO:
				worker1[detail].postMessage({ cmd:'render', filter: FX_CAIRO, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, size:UI.valuef("cairo_size"), angle:UI.valuef("cairo_angle"), randomize:UI.value("cairo_rnd1"), rotation:UI.valuef("cairo_rotation") });
				break;
			case FX_SCATTER:
				worker1[detail].postMessage({ cmd:'render', filter: FX_SCATTER, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, scale:UI.valuef("scatter_scale"), spacing:UI.valuef("scatter_spacing"), shape:UI.value("scatter_shape"), pixel_rand:UI.value("scatter_rnd1"), rotation:UI.valuef("scatter_rotation") });
				break;
			case FX_ZAG:
				worker1[detail].postMessage({ cmd:'render', filter: FX_ZAG, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, thickness:UI.valuef("zag_thickness"), width:UI.valuef("zag_width"), height:UI.valuef("zag_height"), variation:UI.value("zag_variation"), rotation:UI.valuef("zag_rotation"), rand:UI.value("zag_rnd1") });
				break;
			case FX_SEQUENCE:
				worker1[detail].postMessage({ cmd:'render', filter: FX_SEQUENCE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, width:UI.valuef("sequence_width"), height:UI.valuef("sequence_height"), variation:UI.value("sequence_variation"), break_space:UI.value("sequence_break"), shuffle:UI.value("sequence_shuffle"), rand:UI.value("sequence_rnd1"), rotation:UI.value("sequence_rotation") }); break;
				break;
			case FX_ICE:
				worker1[detail].postMessage({ cmd:'render', filter: FX_ICE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, scale:UI.valuef("ice_scale"), spacing:UI.valuef("ice_spacing"), pixel_shape:UI.value("ice_shape"), shuffle:UI.valuef("ice_shuffle"), angle: UI.valuef("ice_angle"), pixel_rand:UI.value("ice_rnd1"), rotation:UI.value("ice_rotation"), shift_x:0, shift_y:0 });
				break;
			case FX_CAPE:
				worker1[detail].postMessage({ cmd:'render', filter: FX_CAPE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l1, detail:detail, detail_data:api_detail_data, scale:UI.valuef("cape_scale"), stripe:UI.value("cape_stripe"), shape:UI.value("cape_shape"), pixel_rand:UI.value("cape_rnd1"), rotation:UI.value("cape_rotation"), shift_x:0, shift_y:0 });
				break;
		}

		switch (fx_selected)
		{
			case FX_PIXFLD:
				worker2[detail].postMessage({ cmd:'render', filter: FX_PIXFLD, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, pixel_size:UI.valuef("pf_width"), pixel_shape:UI.value("pf_shape"), pixel_disp:UI.valuef("pf_displace"), pixel_rand:l==2?UI.value("pf_rnd2"):UI.value("pf_rnd1"), rotation:UI.value("pf_rotation"), shift_x:l==2?PIXFLD_LAYER2_OFFSET:0, shift_y:l==2?PIXFLD_LAYER2_OFFSET:0 });
				break;
			case FX_IKAT:
				worker2[detail].postMessage({ cmd:'render', filter: FX_IKAT, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, step_start:0, step:filter2_step, width:UI.valuef("ikat_width"), shape:UI.value("ikat_shape"), spacing:UI.value("ikat_spacing"), rotation:UI.value("ikat_rotation"), rand_dist:l==2?UI.value("ikat_rnd2"):UI.value("ikat_rnd1") });
				break;
			case FX_STRIPE:
				worker2[detail].postMessage({ cmd:'render', filter: FX_STRIPE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, offset:filter3_step , width:UI.valuef("stripe_width"), variation:UI.value("stripe_variation"), coverage:l==2?75:100, rotation:UI.value("stripe_rotation"), rnd:l==2?UI.value("stripe_rnd2"):UI.value("stripe_rnd1") });
				break;
			case FX_GLACIER:
				worker2[detail].postMessage({ cmd:'render', filter: FX_GLACIER, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, width:UI.valuef("glacier_width"), coverage:l==2?60:100, rotation:UI.valuef("glacier_rotation"), rnd:l==2?UI.value("glacier_rnd2"):UI.value("glacier_rnd1") });
				break;
			case FX_CRIMP:
				worker2[detail].postMessage({ cmd:'render', filter: FX_CRIMP, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, step:filter5_step, width:UI.valuef("crimp_size"), wave:UI.valuef("crimp_wave"), coverage:l==2?60:100, rotation:UI.value("crimp_rotation"), rand_dist:l==2?UI.value("crimp_rnd2"):UI.value("crimp_rnd1") });
				break;
			case FX_THATCH:
				worker2[detail].postMessage({ cmd:'render', filter: FX_THATCH, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, step_start:0, step:filter6_step, width:UI.valuef("thatch_width"), shape:UI.value("thatch_shape"), spacing:UI.valuef("thatch_spacing"), coverage:l==2?60:100, rotation:UI.value("thatch_rotation"), rand_dist:l==2?UI.value("thatch_rnd2"):UI.value("thatch_rnd1") });
				break;
			case FX_CAIRO:
				worker2[detail].postMessage({ cmd:'render', filter: FX_CAIRO, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, size:UI.valuef("cairo_size"), angle:UI.valuef("cairo_angle"), randomize:l==2?UI.value("cairo_rnd2"):UI.value("cairo_rnd1"), rotation:UI.valuef("cairo_rotation") });
				break;
			case FX_SCATTER:
				worker2[detail].postMessage({ cmd:'render', filter: FX_SCATTER, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, scale:UI.valuef("scatter_scale"), spacing:UI.valuef("scatter_spacing"), shape:UI.value("scatter_shape"), pixel_rand:l==2?UI.value("scatter_rnd2"):UI.value("scatter_rnd1"), rotation:UI.valuef("scatter_rotation") });
				break;
			case FX_ZAG:
				worker2[detail].postMessage({ cmd:'render', filter: FX_ZAG, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, thickness:UI.valuef("zag_thickness"), width:UI.valuef("zag_width"), height:UI.valuef("zag_height"), variation:UI.value("zag_variation"), rotation:UI.valuef("zag_rotation"), rand:l==2?UI.value("zag_rnd2"):UI.value("zag_rnd1") });
				break;
			case FX_SEQUENCE:
				worker2[detail].postMessage({ cmd:'render', filter: FX_SEQUENCE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, width:UI.valuef("sequence_width"), height:UI.valuef("sequence_height"), variation:UI.value("sequence_variation"), break_space:UI.value("sequence_break"), shuffle:UI.value("sequence_shuffle"), rand:l==2?UI.value("sequence_rnd2"):UI.value("sequence_rnd1"), rotation:UI.value("sequence_rotation") });
				break;
			case FX_ICE:
				worker2[detail].postMessage({ cmd:'render', filter: FX_ICE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, scale:UI.valuef("ice_scale"), spacing:UI.valuef("ice_spacing"), pixel_shape:UI.value("ice_shape"), shuffle:UI.valuef("ice_shuffle"), angle: UI.valuef("ice_angle"), pixel_rand:l==2?UI.value("ice_rnd2"):UI.value("ice_rnd1"), rotation:UI.value("ice_rotation"), shift_x:0/*ICE_VERT_OFFSET*/, shift_y:0/*ICE_VERT_OFFSET*/ });
				break;
			case FX_CAPE:
				worker2[detail].postMessage({ cmd:'render', filter: FX_CAPE, dim_wid:dim_wid, dim_hei:dim_hei, layer:l2, detail:detail, detail_data:api_detail_data, scale:UI.valuef("cape_scale"), stripe:UI.value("cape_stripe"), shape:UI.valuef("cape_shape"), pixel_rand:l==2?UI.value("cape_rnd2"):UI.value("cape_rnd1"), rotation:UI.value("cape_rotation"), shift_x:l==2?CAPE_LAYER2_OFFSET:0, shift_y:l==2?CAPE_LAYER2_OFFSET:0 });
				break;
		}
	}

function request_node_filtering()
	{
		var filter2_step = UI.valuef("ikat_width")*100/8;
		var filter3_step = UI.valuef("stripe_width") * 0.3;
		var filter5_step = UI.valuef("crimp_size") * 100/0.8;
		var filter6_step = UI.valuef("thatch_width")*100/8;

		var l1 = 0, l2 = 1;
		if (api_layers == 1)
		{
			l1 = 2; l2 = 3;
		}
		var l = api_layers;

		color_precalc();
		console.log("running filter " + fx_selected);
		switch (fx_selected)
		{
			case FX_PIXFLD:
				vectors_l1[0] = vectorize_filter1(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("pf_width"), UI.value("pf_shape"), 0, UI.value("pf_rnd1"), UI.value("pf_rotation"), 0, 0);
				break;
			case FX_IKAT:
				vectors_l1[0] = vectorize_filter2(0, dim_wid, dim_hei, l1, 0, null, filter2_step/2, filter2_step, UI.valuef("ikat_width"), UI.value("ikat_shape"), UI.value("ikat_spacing"), UI.value("ikat_rotation"), UI.value("ikat_rnd1"));
				break;
			case FX_STRIPE:
				vectors_l1[0] = vectorize_stripes(0, dim_wid, dim_hei, l1, 0, null, 0, UI.valuef("stripe_width"), UI.value("stripe_variation"), 100, UI.value("stripe_rotation"), UI.value("stripe_rnd1"));
				break;
			case FX_GLACIER:
				vectors_l1[0] = vectorize_glacier(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("glacier_width"), 100, UI.valuef("glacier_rotation"), UI.value("glacier_rnd1"));
				break;
			case FX_CRIMP:
				vectors_l1[0] = vectorize_crimp(0, dim_wid, dim_hei, l1, 0, null, filter5_step, UI.valuef("crimp_size"), UI.valuef("crimp_wave"), 95, UI.value("crimp_rotation"), UI.value("crimp_rnd1"));
				break;
			case FX_THATCH:
				vectors_l1[0] = vectorize_thatch(0, dim_wid, dim_hei, l1, 0, null, filter6_step/2, filter6_step, UI.valuef("thatch_width"), UI.value("thatch_shape"), UI.valuef("thatch_spacing"), 80, UI.value("thatch_rotation"), UI.value("thatch_rnd1"));
				break;
			case FX_CAIRO:
				vectors_l1[0] = vectorize_cairo(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("cairo_size"), UI.valuef("cairo_angle"), UI.value("cairo_rnd1"), UI.valuef("cairo_rotation"));
				break;
			case FX_SCATTER:
				vectors_l1[0] = vectorize_scatter(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("scatter_scale"), UI.valuef("scatter_spacing"), UI.value("scatter_shape"), UI.value("scatter_rnd1"), UI.valuef("scatter_rotation"));
				break;
			case FX_ZAG:
				vectors_l1[0] = vectorize_zag(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("zag_thickness"), UI.valuef("zag_width"), UI.valuef("zag_height"), UI.value("zag_variation"), UI.valuef("zag_rotation"), UI.value("zag_rnd1"));
				break;
			case FX_SEQUENCE:
				vectors_l1[0] = vectorize_sequence(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("sequence_width"), UI.valuef("sequence_height"), UI.value("sequence_variation"), UI.value("sequence_break"), UI.value("sequence_shuffle"), UI.value("sequence_rnd1"), UI.value("sequence_rotation"));
				break;
			case FX_ICE:
				vectors_l1[0] = vectorize_ice(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("ice_scale"), UI.valuef("ice_spacing"), UI.value("ice_shape"), UI.valuef("ice_shuffle"), UI.valuef("ice_angle"), UI.value("ice_rnd1"), UI.value("ice_rotation"), 0, 0);
				break;
			case FX_CAPE:
				vectors_l1[0] = vectorize_cape(0, dim_wid, dim_hei, l1, 0, null, UI.valuef("cape_scale"), UI.value("cape_stripe"), UI.valuef("cape_shape"), UI.value("cape_rnd1"), UI.value("cape_rotation"), 0, 0);
				break;
		}

		switch (fx_selected)
		{
			case FX_PIXFLD:
				vectors_l2[0] = vectorize_filter1(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("pf_width"), UI.value("pf_shape"), UI.valuef("pf_displace"), l==2?UI.value("pf_rnd2"):UI.value("pf_rnd1"), UI.value("pf_rotation"), l==2?PIXFLD_LAYER2_OFFSET:0, l==2?PIXFLD_LAYER2_OFFSET:0);
				break;
			case FX_IKAT:
				vectors_l2[0] = vectorize_filter2(0, dim_wid, dim_hei, l2, 0, null, 0, filter2_step, UI.valuef("ikat_width"), UI.value("ikat_shape"), UI.value("ikat_spacing"), UI.value("ikat_rotation"), l==2?UI.value("ikat_rnd2"):UI.value("ikat_rnd1"));
				break;
			case FX_STRIPE:
				vectors_l2[0] = vectorize_stripes(0, dim_wid, dim_hei, l2, 0, null, filter3_step , UI.valuef("stripe_width"), UI.value("stripe_variation"), l==2?75:100, UI.value("stripe_rotation"), l==2?UI.value("stripe_rnd2"):UI.value("stripe_rnd1"));
				break;
			case FX_GLACIER:
				vectors_l2[0] = vectorize_glacier(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("glacier_width"), l==2?60:100, UI.valuef("glacier_rotation"), l==2?UI.value("glacier_rnd2"):UI.value("glacier_rnd1"));
				break;
			case FX_CRIMP:
				vectors_l2[0] = vectorize_crimp(0, dim_wid, dim_hei, l2, 0, null, filter5_step, UI.valuef("crimp_size"), UI.valuef("crimp_wave"), l==2?60:100, UI.value("crimp_rotation"), l==2?UI.value("crimp_rnd2"):UI.value("crimp_rnd1"));
				break;
			case FX_THATCH:
				vectors_l2[0] = vectorize_thatch(0, dim_wid, dim_hei, l2, 0, null, 0, filter6_step, UI.valuef("thatch_width"), UI.value("thatch_shape"), UI.valuef("thatch_spacing"), l==2?60:100, UI.value("thatch_rotation"), l==2?UI.value("thatch_rnd2"):UI.value("thatch_rnd1"));
				break;
			case FX_CAIRO:
				vectors_l2[0] = vectorize_cairo(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("cairo_size"), UI.valuef("cairo_angle"), l==2?UI.value("cairo_rnd2"):UI.value("cairo_rnd1"), UI.valuef("cairo_rotation"));
				break;
			case FX_SCATTER:
				vectors_l2[0] = vectorize_scatter(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("scatter_scale"), UI.valuef("scatter_spacing"), UI.value("scatter_shape"), l==2?UI.value("scatter_rnd2"):UI.value("scatter_rnd1"), UI.valuef("scatter_rotation"));
				break;
			case FX_ZAG:
				vectors_l2[0] = vectorize_zag(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("zag_thickness"), UI.valuef("zag_width"), UI.valuef("zag_height"), UI.value("zag_variation"), UI.valuef("zag_rotation"), l==2?UI.value("zag_rnd2"):UI.value("zag_rnd1"));
				break;
			case FX_SEQUENCE:
				vectors_l2[0] = vectorize_sequence(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("sequence_width"), UI.valuef("sequence_height"), UI.value("sequence_variation"), UI.value("sequence_break"), UI.value("sequence_shuffle"), l==2?UI.value("sequence_rnd2"):UI.value("sequence_rnd1"), UI.value("sequence_rotation"));
				break;
			case FX_ICE:
				vectors_l2[0] = vectorize_ice(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("ice_scale"), UI.valuef("ice_spacing"), UI.value("ice_shape"), UI.valuef("ice_shuffle"), UI.valuef("ice_angle"), l==2?UI.value("ice_rnd2"):UI.value("ice_rnd1"), UI.value("ice_rotation"), ICE_VERT_OFFSET, ICE_VERT_OFFSET);
				break;
			case FX_CAPE:
				vectors_l2[0] = vectorize_cape(0, dim_wid, dim_hei, l2, 0, null, UI.valuef("cape_scale"), UI.value("cape_stripe"), UI.valuef("cape_shape"), l==2?UI.value("cape_rnd2"):UI.value("cape_rnd1"), UI.value("cape_rotation"), l==2?CAPE_LAYER2_OFFSET:0, l==2?CAPE_LAYER2_OFFSET:0);
				break;
		}
	}

if (typeof pf_nodejs === "undefined")
{
 	var canvas_bitmap = document.getElementById('bitmap_data');
	var context_bitmap = canvas_bitmap.getContext('2d');
}
else
{
	var canvas_bitmap = new Canvas.Canvas(1024, 1024);
	var context_bitmap = canvas_bitmap.getContext('2d');
}

UI.register_eval_callback(UI_change_eval);
var img_fill_color = new RGB(128,128,128);
var img_cast_color = new RGB(0xFF, 0xE1, 0x00);
UI.setValue("color", img_fill_color);
UI.setValue("cast_color", img_cast_color);
new_val();

//set_filter(fx_selected);

if (typeof pf_nodejs === "undefined")
{
	window.requestAnimFrame = (function(callback) {
		return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame ||
		function(callback) {
			window.setTimeout(callback, 1000 / 20);
		};
	})();

	var web_anim_do = function() { requestAnimFrame(function() { web_animate(); }) };
	web_animate();
}

if (typeof dev_pflab !== "undefined") set_filter(fx_selected);
